const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

const replaceHTMLAttributes = (
  htmlString,
  attributeName,
  replacementString,
) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(
    regex,
    `${attributeName}="${replacementString}"`,
  );

  return modifiedHTML;
};

const removeHTMLAttributes = (htmlString, attributeName) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(regex, "");

  return modifiedHTML;
};

const triggerEvent = (element, name, data = {}) => {
  window.events = window.events || {};
  if (!window.events[name]) {
    window.events[name] = debounce((element, name, data) => {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        }),
      );
    }, 300);
  }
  window.events[name](element, name, data);
};

const delegate = (parent, eventName, childSelector, callback) => {
  if (typeof childSelector === "function") {
    callback = childSelector;
    childSelector = null;
  }
  const selector = childSelector
    ? childSelector
    : "." + [...parent.classList].join(".").replaceAll(":", "\\:");
  parent.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (target) {
      callback(event, target);
    }
  });
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (e) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("model-viewer")
    .forEach((model) => model.modelViewerUI?.pause());
}

function pauseThisMedia(media) {
  if (media.tagName === "VIDEO") {
    media.pause();
  } else if (media.tagName === "IFRAME") {
    if (media.classList.contains("js-youtube")) {
      media.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
        "*",
      );
    } else if (media.classList.contains("js-vimeo")) {
      media.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else if (media.tagName === "MODEL-VIEWER") {
    media.modelViewerUI?.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class DisclosureElement extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector("button"),
    };
    this.elements.button.addEventListener("click", this.toggle.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.listItems = this.querySelectorAll("li[data-value]");
    this.listItems.forEach((item) =>
      item.addEventListener("click", this.onListItemClick.bind(this)),
    );
  }

  // Cleanup function to remove the event listener when the element is disconnected
  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  onListItemClick(event) {
    const listItem = event.currentTarget;
    const value = listItem.dataset.value;
    this.querySelector(".selected-value").innerText = value;
    this.close();
    this.listItems.forEach((item) => item.classList.remove("font-bold"));
    listItem.classList.add("font-bold");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.close();
    this.elements.button.focus();
  }

  toggle() {
    const isExpanded =
      this.elements.button.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.elements.button.setAttribute("aria-expanded", "true");
    document.addEventListener(
      "click",
      this.handleDocumentClick.bind(this),
      true,
    );
  }

  close() {
    this.elements.button.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    const isOutsideClick = !this.contains(event.target);
    if (isOutsideClick) {
      this.close();
    }
  }
}

customElements.define("disclosure-element", DisclosureElement);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.dropdown-trigger)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement =
      event.target.parentElement.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement =
      detailsElement.parentElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const input = summaryElement.querySelector("input");
    if (input) input.checked = !input.checked;

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 1);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut(e) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.parentElement.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement =
      detailsElement.parentElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 1) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.parentElement.closest("details[open]")) {
          trapFocus(
            detailsElement.parentElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.menuDrawer = this.querySelector("#menu-drawer");
    if (this.menuDrawer) {
      const amount = parseInt(
        window.getComputedStyle(document.querySelector("header-element"))
          .paddingBottom,
      );
      this.querySelector("#menu-drawer").style.marginTop = -amount + "px";
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector("header-element");
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
    // window.scrollTo(0, 0);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (event.target.classList.contains("_modalClose")) this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  async show(opener) {
    opener.querySelector(".spinner")?.classList.remove("hidden");
    await this.querySelector(".template-popup")?.loadContent();
    await this.querySelector("section-fetcher")?.checkAndFetch();
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("opening", "");
    setTimeout(() => {
      this.setAttribute("open", "");
      this.removeAttribute("opening");
    }, 1);
    trapFocus(this, this.querySelector('[role="dialog"]'));
    opener.querySelector(".spinner")?.classList.add("hidden");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

const fetchElement = async (url, tagName, targetNode) => {
  return fetch(url)
    .then((response) => response.text())
    .then((html) => {
      if (targetNode) {
        html = html.replaceAll(
          "api--product-card",
          targetNode.dataset.sectionId,
        );
      }
      let doc = new DOMParser().parseFromString(html, "text/html");
      if (doc.getElementsByTagName(tagName)[0]) {
        return doc.getElementsByTagName(tagName)[0];
      }
    })
    .catch(status, (err) => {
      console.error(err);
    });
};

function lockScrollForThis(element) {
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
  element.dataset.scrollY = scrollY;
}

function unlockScrollForThis(element) {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo({
    behavior: "instant",
    left: 0,
    top: parseInt(element.dataset.scrollY || "0"),
  });
}

function preventDefault(e) {
  e.preventDefault();
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (!customElements.get("quantity-input")) {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      this.changeEvent = new Event("change", { bubbles: true });
      this.form = this.querySelector("form");
      this.quantityDisplay = this.querySelector("[data-quantity-display]");

      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this)),
      );
      this.input.addEventListener("change", this.onInputChange.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      this.previousValue = this.input?.value;

      event.currentTarget.ariaLabel === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();

      if (this.dataset.mode == "qty") return;

      if (this.previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
      this.querySelector(".hide-when-spinner")?.classList.add("opacity-0");
      const spinner = this.querySelector('.spinner')
      if(spinner) {
        spinner.classList.remove('hidden')
        spinner.querySelector('svg').classList.add('animate-spin')
      }

      document.querySelectorAll(".cart-spinner").forEach((spinner) => {
        spinner.classList.remove("hidden");
      });
    }

    onInputChange(event) {
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);

      this.dynamicSectionsNodes = document.querySelectorAll("cart-dynamic");

      let dynamicSections = [];
      if (this.dynamicSectionsNodes) {
        dynamicSections = [...this.dynamicSectionsNodes].map(
          (item) => item.dataset.sectionId,
        );
      }

      formData.append("sections", dynamicSections.join(","));
      config.body = formData;

      let url =
        this.dataset.quantity == 0
          ? routes.cart_add_url
          : routes.cart_change_url;

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 422) {
            this.input.value = this.previousValue;
            this.handleErrorMessage(response.message);
          }
          if (
            response.item_count === 0 &&
            window.location.pathname === "/cart"
          ) {
            window.location.reload();
          }

          this.response = response;

          let cartItem =
            this.dataset.quantity == 0
              ? response
              : response.items.find(
                  (item) => item.variant_id == this.dataset.id,
                );

          this.dataset.quantity = cartItem ? cartItem.quantity : 0;
          this.quantityDisplay.innerText = this.dataset.quantity;

          this.updateClones();

          // update dynamic sections
          this.dynamicSectionsNodes.forEach((node) => {
            const htmlString = this.response.sections[node.dataset.sectionId];
            const html = new DOMParser().parseFromString(
              htmlString,
              "text/html",
            );
            node.animate([{ opacity: 0 }, { opacity: 1 }], {
              duration: 150,
              easing: "ease-in-out",
              fill: "forwards",
            });
            node.innerHTML = html.querySelector(
              `cart-dynamic[data-section-id='${node.dataset.sectionId}']`,
            ).innerHTML;
            node.classList = html.querySelector(
              `cart-dynamic[data-section-id='${node.dataset.sectionId}']`,
            ).classList;
            node.animate([{ opacity: 0 }, { opacity: 1 }], {
              duration: 150,
              easing: "ease-in-out",
              fill: "forwards",
            });
            node.modified();
          });

          // if the cart is updated, trigger the event
          // add the tag name of this
          triggerEvent(document, "cart:update", {
            source: this.tagName.toLowerCase(),
            found: response.item_count > 0,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const spinner = this.querySelector('.spinner')
          if(spinner) {
            spinner.classList.add('hidden')
            spinner.querySelector('svg').classList.remove('animate-spin')
          }
          this.querySelector(".hide-when-spinner")?.classList.remove(
            "opacity-0",
          );
          document.querySelectorAll(".cart-spinner").forEach((spinner) => {
            spinner.classList.add("hidden");
          });
        });
    }

    updateClones() {
      const clones = document.querySelectorAll(
        `quantity-input[data-id="${this.dataset.id}"]:not([data-mode="qty"])`,
      );

      for (const clone of clones) {
        if (clone == this) continue;
        if (clone.dataset.linkMode == "true") continue;

        clone.dataset.quantity = this.dataset.quantity;
        clone.quantityDisplay.innerText = this.dataset.quantity;
        clone.input.value = this.dataset.quantity;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrappers =
        this.errorMessageWrappers || this.querySelectorAll("error-message");

      this.errorMessageWrappers.forEach((errorMessageWrapper) => {
        if (errorMessage) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = errorMessage;
          errorMessageWrapper.classList.remove("hidden");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
          }, 3000);
        } else {
          errorMessageWrapper.classList.add("hidden");
        }
      });
      throw new Error(errorMessage);
    }
  }
  customElements.define("quantity-input", QuantityInput);
}

class SectionFetcher extends HTMLElement {
  static observedAttributes = [
    "data-url",
    "data-section-id",
    "data-selector",
    "data-animate",
    "data-fire-event",
    "data-onload",
    "data-load-on-event",
  ];

  constructor() {
    super();
    this.handlePopState = this.handlePopState.bind(this);
    this.debouncedCheckAndFetch = this.debounce(
      this.checkAndFetch.bind(this),
      250,
    );
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.setupInitialState();
    this.addEventListeners();
    this.reWriteData();
    if (this.dataset.onload === "true") {
      this.setupIntersectionObserver();
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
    this.removeIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      rootMargin: "0px 0px 800px 0px",
      threshold: 0,
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.dataset.onload === "true") {
          queueMicrotask(() => this.checkAndFetch(true));
          this.removeIntersectionObserver();
        }
      });
    }, options);

    this.intersectionObserver.observe(this);
  }

  removeIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || name !== "data-url") return;
    this.debouncedCheckAndFetch(false, true);
  }

  setupInitialState() {
    const defaultUrl = new URL(window.location.href);
    defaultUrl.searchParams.delete("section_id");
    this.dataset.url = this.dataset.url || defaultUrl.toString();
    this.lastFetchedUrl = this.dataset.url || window.location.href;

    // add feed heights for pagination
    if (this.querySelector("pagination-element")) {
      // reset saved heights for pagination
      window.addEventListener("resize", () => (window.feedHeights = {}));
      this.saveFeedTemporarily();
      this.fixHeight();
      const resetHeight = () => {
        if (this.style.height === "") return;
        setTimeout(() => {
          this.style.height = window.feedHeights[this.dataset.url] + "px";
          setTimeout(() => {
            this.style.height = "";
          }, 800);
        }, 300);
      };

      this.addEventListener("mouseleave", resetHeight);
      if ('ontouchstart' in window) {
        window.addEventListener("scroll", resetHeight, { passive: true });
      }
    }
  }

  addEventListeners() {
    if (!this.disablePopEvents) {
      window.addEventListener("popstate", this.handlePopState, {
        passive: true,
      });
    }
    if (this.dataset.loadOnEvent) {
      window.addEventListener(this.dataset.loadOnEvent, this.handlePopState, {
        passive: true,
      });
    }
  }

  removeEventListeners() {
    window.removeEventListener("popstate", this.handlePopState);
    if (this.dataset.loadOnEvent) {
      window.removeEventListener(this.dataset.loadOnEvent, this.handlePopState);
    }
  }

  handlePopState() {
    this.dataset.url = this.buildFetchUrl(window.location.href);
    this.debouncedCheckAndFetch(false);
  }

  async checkAndFetch(isInitialLoad = true, isAttributeChange) {
    const currentUrl = new URL(this.dataset.url, window.location.origin);
    const dataUrl = new URL(this.lastFetchedUrl, window.location.origin);

    const relevantParams = new Set([
      "sort_by",
      "page",
      "q",
      ...Array.from(dataUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
      ...Array.from(currentUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
    ]);

    let shouldFetch = isInitialLoad;

    for (const param of relevantParams) {
      const currentValues = currentUrl.searchParams.getAll(param);
      const dataValues = dataUrl.searchParams.getAll(param);

      if (param === "page" && currentValues[0] == 1 && dataValues.length === 0)
        return;

      if (JSON.stringify(currentValues) !== JSON.stringify(dataValues)) {
        shouldFetch = true;
        dataUrl.searchParams.delete(param); // Remove all existing values for this param
        currentValues.forEach((value) => {
          dataUrl.searchParams.append(param, value); // Add each value individually
        });
      }
    }

    if (shouldFetch) {
      const newUrl = dataUrl.toString();
      const fetchUrl = this.buildFetchUrl(newUrl);

      if (fetchUrl !== this.lastFetchedUrl) {
        this.lastFetchedUrl = fetchUrl;
        await this.fetchAndReplaceContent(fetchUrl, isAttributeChange);
        return true;
      }
    }
  }

  buildFetchUrl(url) {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", this.dataset.sectionId);
    return fetchUrl.toString();
  }

  fixHeight() {
    // skip if touch device
    // if ("ontouchstart" in window) return;
    // define defaults
    window.feedHeights = window.feedHeights || {};
    window.feedHeights[this.id] = window.feedHeights[this.id] || [];
    window.feedHeights[this.dataset.url] =
      window.feedHeights[this.dataset.url] || [];
    // save height
    window.feedHeights[this.id].push(this.offsetHeight);
    window.feedHeights[this.dataset.url] = this.offsetHeight;
    // unique values
    window.feedHeights[this.id] = [...new Set(window.feedHeights[this.id])];
    // from big to small
    window.feedHeights[this.id].sort((a, b) => b - a);
    // set height
    if (window.feedHeights[this.id][0] === 0) return;
    this.style.height = window.feedHeights[this.id][0] + "px";
  }

  saveFeedTemporarily(url = this.buildFetchUrl(this.dataset.url)) {
    window.temporaryFeeds = window.temporaryFeeds || {};
    Object.keys(window.temporaryFeeds).forEach((key) => {
      if (key !== this.id) {
        delete window.temporaryFeeds[key];
      }
    });
    window.temporaryFeeds[this.id] = window.temporaryFeeds[this.id] || {};
    window.temporaryFeeds[this.id][url] = this.outerHTML;
  }

  clearTemporaryFeed() {
    setTimeout(() => (window.temporaryFeeds = {}), 1000);
  }

  keepData() {
    if (!this.dataset.toKeep) return;
    window.temporaryDatas = window.temporaryDatas || {};
    window.temporaryDatas[this.id] = {};
    this.dataset.toKeep.split(",").forEach((data) => {
      window.temporaryDatas[this.id][data] = this.dataset[data];
    });
    setTimeout(() => (window.temporaryDatas = {}), 3000);
  }

  reWriteData() {
    if (!window.temporaryDatas || !window.temporaryDatas[this.id]) return;
    Object.entries(window.temporaryDatas[this.id]).forEach(([key, value]) => {
      this.dataset[key] = value;
    });
  }

  async fetchAndReplaceContent(url, isAttributeChange) {
    try {
      this.keepData();
      let newContent;
      if (
        window.temporaryFeeds &&
        window.temporaryFeeds[this.id] &&
        window.temporaryFeeds[this.id][this.dataset.url]
      ) {
        newContent = this.parseHTML(
          window.temporaryFeeds[this.id][this.dataset.url],
        );
        this.dataset.animate = "false";
      }

      if (!newContent) {
        if (isAttributeChange) {
          this.fixHeight();
        }
        if (isAttributeChange) {
          this.fixHeight();
        }
        const response = await this.fetchWithRetry(url);
        const html = await response.text();
        newContent = this.parseHTML(html);
        if (newContent === null) {
          this.remove();
          return;
        }
      }

      if (this.dataset.animate !== "false") {
        await this.animateTransition(newContent);
      } else {
        this.replaceWith(newContent);
      }

      this.fireCustomEvent(newContent);
      return true;
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  }

  async fetchWithRetry(url, retries = 3) {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        return response;
      } catch (error) {
        if (i === retries - 1) throw error;
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * Math.pow(2, i)),
        );
      }
    }
  }

  parseHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (
      doc.querySelector(`[data-section-id="${this.dataset.sectionId}"]`) ??
      doc.querySelector(`[data-section="${this.dataset.sectionId}"]`)
    );
  }

  async animateTransition(newContent) {
    await this.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 100,
    }).finished;

    this.replaceWith(newContent);

    this.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 100,
    });
  }

  replaceContent(newContent) {
    replaceNodeWithNodeList(this, newContent);
  }

  fireCustomEvent(newContent) {
    if (this.dataset.fireEvent) {
      const event = new CustomEvent(this.dataset.fireEvent, {
        bubbles: true,
        detail: {
          source: this.dataset.id,
          found: newContent.length > 0,
        },
      });
      this.dispatchEvent(event);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define("section-fetcher", SectionFetcher);

if (!customElements.get("cart-dynamic")) {
  customElements.define(
    "cart-dynamic",
    class CartDynamic extends SectionFetcher {
      constructor() {
        super();
        this.disablePopEvents = true;
      }

      connectedCallback() {
        super.connectedCallback();
        document.addEventListener("cart:update", (e) => {
          if (e.detail.source !== "quantity-input") {
            this.fetchAndReplaceContent();
          }
        });
      }

      modified(miliseconds = 1000) {
        this.dataset.modified = true;

        setTimeout(() => {
          this.removeAttribute("data-modified");
        }, miliseconds);
      }
    },
  );
}

const updateSearchParams = (searchParams, keepKeys) => {
  // summarize what this function does
  // it takes the current url and updates the search params with the new search params
  const urlParams = new URLSearchParams(window.location.search);
  const activeParams = [];
  const newParams = searchParams.split("&");
  if (keepKeys) {
    urlParams.forEach((value, key) => {
      if (keepKeys.includes(key)) {
        newParams.push(`${key}=${value}`);
      }
    });
  }

  const baseUrl = window.location.href.split("?")[0];
  return `${baseUrl}?${newParams.join("&")}`;
};

class TabComponent extends HTMLElement {
  // use as
  //         <tab-component data-tab-wrapper-styles-add="flex justify-center">
  //          <div label="tab1">content</div>
  //         <div label="tab2" style="display:none;" >content</div>

  constructor() {
    super();

    this.tabWrapperStyles =
      this.dataset.tabWrapperStyles ||
      `mx-2 md:mx-0 inline-flex overflow-hidden border border-body/50 rounded-sm flex-wrap ${this.dataset.tabWrapperStylesAdd}`;
    this.tabStyles =
      this.dataset.tabStyles ||
      `px-3 py-2 cursor-pointer ${this.dataset.tabStylesAdd}`;
    this.deactiveTabStyles =
      this.dataset.deactiveTabStyles ||
      `hover:bg-background1 first:border-l-0 last:border-r-0 border-x border-body/50 bg-background2 ${this.dataset.deactiveTabStylesAdd}`;
    this.activeTabStyles =
      this.dataset.activeTabStyles ||
      `bg-accent1 text-accent1_fg first:border-l-0 last:border-r-0 border-x border-accent1 cursor-default shadow-sm ${this.dataset.activeTabStylesAdd}`;
    this.contentStyles = this.dataset.contentStyles || "py-5";
  }

  connectedCallback() {
    this.render();
    this.selectTab(0);
  }

  render() {
    this.innerHTML = `
    <div>
      <div class="tab-list ${this.tabWrapperStyles}" role="tablist">
        ${this.createTabs()}
      </div>
      <div class="tab-content ${this.contentStyles}">
        ${this.createContent()}
      </div>
    </div>
    `;

    this.registerClickEvent();
  }

  createTabs() {
    return [...this.children]
      .map((child, index) => {
        return `<button class="tab-list-item ${this.tabStyles} ${
          index === 0 ? this.activeTabStyles : this.deactiveTabStyles
        }" data-index="${index}" role="tab" tabindex="${
          index === 0 ? "0" : "-1"
        }" aria-selected="${
          index === 0 ? "true" : "false"
        }">${child.getAttribute("label")}</button>`;
      })
      .join("");
  }

  createContent() {
    return [...this.children]
      .map((child, index) => {
        return `<div class="tab-content-item" data-index="${index}" role="tabpanel" tabindex="0" style="display: none;">${child.innerHTML}</div>`;
      })
      .join("");
  }

  registerClickEvent() {
    this.querySelectorAll(".tab-list-item").forEach((tab, index) => {
      tab.addEventListener("click", () => this.selectTab(index));
    });
  }

  selectTab(index) {
    let activeTabClasses = this.activeTabStyles.split(" ");
    let deactiveTabClasses = this.deactiveTabStyles.split(" ");

    this.querySelectorAll(".tab-list-item").forEach((tab, i) => {
      tab.classList.add(...deactiveTabClasses);
      tab.classList.remove(...activeTabClasses);
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });

    this.querySelectorAll(".tab-list-item")[index].classList.add(
      ...activeTabClasses,
    );
    this.querySelectorAll(".tab-list-item")[index].classList.remove(
      ...deactiveTabClasses,
    );
    this.querySelectorAll(".tab-list-item")[index].setAttribute(
      "aria-selected",
      "true",
    );
    this.querySelectorAll(".tab-list-item")[index].setAttribute(
      "tabindex",
      "0",
    );

    this.querySelectorAll(".tab-content-item").forEach((child, i) => {
      child.style.display = "none";
      child.setAttribute("aria-hidden", "true");
    });

    this.querySelectorAll(".tab-content-item")[index].style.display = "block";
    this.querySelectorAll(".tab-content-item")[index].setAttribute(
      "aria-hidden",
      "false",
    );
  }
}

window.customElements.define("tab-component", TabComponent);

function handleImageError(imgElement) {
  imgElement.classList.add("hidden");
  const fallback = imgElement.parentElement.querySelector(".fallback");
  fallback.classList.remove("hidden");
}

customElements.define(
  "eye-in-the-sky",
  class EyeInTheSky extends HTMLElement {
    constructor() {
      super();
      this.password = document.getElementById(this.dataset.target);
    }

    connectedCallback() {
      this.addEventListener("click", () => this.handleClick());
    }

    handleClick() {
      this.classList.toggle("active");
      const isPassword = this.password.type === "password";
      this.password.type = isPassword ? "text" : "password";
    }
  },
);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300),
    );
  }
}

customElements.define("cart-note", CartNote);
if (!customElements.get("slider-component")) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("ul");
      this.sliderItems = this.querySelectorAll(".slider-items");
      this.sliderThumbnails = this.querySelectorAll("slider-thumbnails li");
      this.pageCount = this.querySelector(".slider-counter--current");
      this.pageTotal = this.querySelector(".slider-counter--total");
      this.prevButton = this.querySelector('button[aria-label="previous"]');
      this.nextButton = this.querySelector('button[aria-label="next"]');

      this.initThumbnails();

      this.lightbox = this.querySelector(".lightbox");
      if (this.lightbox) this.initLightbox();

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener("scroll", this.update.bind(this));
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

      this.initVideoListeners();
    }

    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(
        this.slider.clientWidth / this.sliderItems[0].clientWidth,
      );
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }

    initThumbnails() {
      this.sliderThumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          this.slideTo(index);
        });
      });
    }

    initVideoListeners() {
      const videoElements = this.querySelectorAll(
        "video, .js-youtube, .js-vimeo",
      );
      videoElements.forEach((video) => {
        // is video intersecting
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              pauseThisMedia(video);
            } else {
              if (video.tagName === "VIDEO" && video.autoplay) video.play();
            }
          });
        });
        observer.observe(video);
      });
    }

    update() {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) +
        1;

      const img = this.sliderItems[this.currentPage]?.querySelector("img");
      if (img && !img.complete) {
        const image = new Image();
        image.src = img.src;
        if (img.srcset) image.srcset = img.srcset;
      }

      if (this.currentPage === 1) {
        this.prevButton.setAttribute("disabled", true);
      } else {
        this.prevButton.removeAttribute("disabled");
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute("disabled", true);
      } else {
        this.nextButton.removeAttribute("disabled");
      }

      if (!this.pageCount || !this.pageTotal) return;
      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    slideTo(index) {
      this.slider.scrollTo({
        left: this.sliderItems[0].clientWidth * index,
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
          : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }

    initLightbox() {
      this.lightboxSlider = this.lightbox.querySelector("slider-component ul");
      this.sliderItems.forEach((item, index) => {
        const trigger = item.classList.contains("js-lightbox")
          ? item
          : item.querySelector(".js-lightbox");
        trigger?.addEventListener("click", () => {
          this.lightbox.querySelector("fader-component").activate(index);
          this.lightbox.classList.replace("hidden", "fixed");
          // record the scroll position
          this.scrollPosition = window.scrollY;
          document.body.classList.add("fixed");
        });
      });

      this.slider.addEventListener("scroll", (e) => {
        this.lightboxSlider.scrollLeft =
          (this.slider.scrollLeft / this.slider.scrollWidth) *
          this.lightboxSlider.scrollWidth;
      });

      this.lightboxCloser = this.lightbox.querySelector("#close-lightbox");

      this.lightboxCloser.addEventListener("click", () => {
        document.body.classList.remove("fixed");
        pauseAllMedia();
        this.lightbox.classList.replace("fixed", "hidden");
        // instant scroll
        window.scrollTo({
          top: this.scrollPosition,
          behavior: "instant",
        });
      });
    }
  }

  customElements.define("slider-component", SliderComponent);
}

if (!customElements.get("fader-component")) {
  class FaderComponent extends HTMLElement {
    constructor() {
      super();
      this.sliderItems = this.querySelectorAll(".fader-item");
      this.sliderThumbnails = this.querySelectorAll(`fader-thumbnails li`);
      this.initThumbnails();
    }

    initThumbnails() {
      this.sliderThumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          this.activate(index);
        });
      });
    }

    activate(index) {
      this.querySelectorAll(".fader-item img").forEach((img) => {
        if (img.complete) return;
        const image = new Image();
        image.src = img.src;
        if (img.srcset) image.srcset = img.srcset;
      });
      this.sliderItems.forEach((item) => item.classList.add("hidden"));
      this.sliderItems[index].classList.remove("hidden");
    }
  }

  customElements.define("fader-component", FaderComponent);
}
if (!customElements.get("electric-slider")) {
  class SnapSlider extends HTMLElement {
    constructor() {
      super();
      this.state = {
        isDragging: false,
        wasDragged: false,
        dragThreshold: 10,
        pos: { left: 0, x: 0 },
        isTransitioning: false,
        lastWheelTime: 0
      };
      
      this.observers = [];
      this.eventRegistry = [];
      this.items = [];
      
      // Pre-bind critical methods to avoid repeated binding
      this.dragMove = this.dragMove.bind(this);
      this.dragEnd = this.dragEnd.bind(this);
      this.resetScrollSnap = this.resetScrollSnap.bind(this);
    }

    connectedCallback() {
      try {
        this.cacheElements();
        this.setupObservers();
        this.attachEvents();
        
        // Reset drag state if drag is disabled
        if (this.dataset.drag === "false") {
          this.state.wasDragged = false;
          this.state.isDragging = false;
        }
      } catch (error) {
        console.error('SnapSlider initialization error:', error);
      }
    }

    disconnectedCallback() {
      this.detachEvents();
      this.disconnectObservers();
    }

    get els() {
      const target = this.dataset.id;
      return {
        slider: this.querySelector("electric-feed") || (() => { throw new Error("Slider feed not found"); })(),
        prevBtn: document.querySelector(`button[aria-label="previous"][data-slider-target="${target}"]`),
        nextBtn: document.querySelector(`button[aria-label="next"][data-slider-target="${target}"]`),
        gradient: this.querySelector("gradient-finish"),
        dots: this.querySelector('.electric-slider__dots'),
        thumbnails: this.querySelector('.electric-slider__thumbnails'),
        sliderBar: this.querySelector(`[data-slider-target="${target}"].electric-slider__bar`),
      }
    }

    cacheElements() {
      this.els.prevWrapper = this.els.prevBtn?.parentElement === this ? 
        this.els.prevBtn : this.els.prevBtn?.parentElement;
        
      // Set cursor based on drag state
      if (this.els.sliderBar) {
        this.els.sliderBar.style.cursor = this.dataset.drag === "false" ? 'default' : 'grab';
      }
    }

    attachEvents() {
      const { slider, prevBtn, nextBtn, sliderBar } = this.els;
      
      // Common event handler setup
      // Only prevent clicks if drag is enabled AND was dragged
      if (this.dataset.drag !== "false") {
        this.addEvent(slider, 'click', e => this.state.wasDragged && (e.preventDefault(), e.stopPropagation(), this.state.wasDragged = false), true);
      }
      this.addEvent(slider, 'scroll', () => this.throttleUpdate(), { passive: true });
      
      // Drag events
      if (this.dataset.drag !== "false") {
        this.addEvent(slider, 'mousedown', e => this.startDrag(e));
        if (this.dataset.carouselMode === "fade") {
          this.addEvent(slider, 'touchstart', e => {
            // Store initial touch position
            this.state.initialTouch = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY,
              time: Date.now()
            };
            
            // Don't prevent default yet, we'll do it in touchmove if needed
            this.startDrag(e, false);
          }, { passive: true });
        }
      }
      
      // Fade mode specific
      if (this.dataset.carouselMode === "fade") {
        this.addEvent(slider, 'wheel', e => this.handleWheel(e), { passive: false });
      }
      
      // Navigation buttons
      this.addEvent(prevBtn, 'click', e => this.handleDirectionClick(e));
      this.addEvent(nextBtn, 'click', e => this.handleDirectionClick(e));
      
      // Slider bar - only enable if drag is enabled
      if (sliderBar && this.dataset.drag !== "false") {
        this.addEvent(sliderBar, 'mousedown', e => this.startBarDrag(e));
        this.addEvent(sliderBar, 'touchstart', e => this.startBarDrag(e), { passive: false });
      }
    }
    
    addEvent(element, eventType, handler, options = {}) {
      if (!element) return;
      element.addEventListener(eventType, handler, options);
      this.eventRegistry.push([element, eventType, handler, options]);
    }

    detachEvents() {
      this.eventRegistry.forEach(([element, eventType, handler, options]) => {
        element?.removeEventListener(eventType, handler, options);
      });
      this.eventRegistry = [];
      this.cleanUpGlobalEvents();
    }

    cleanUpGlobalEvents() {
      document.removeEventListener('mousemove', this.dragMove);
      document.removeEventListener('touchmove', this.dragMove);
      document.removeEventListener('mouseup', this.dragEnd);
      document.removeEventListener('mouseleave', this.dragEnd);
      document.removeEventListener('touchend', this.dragEnd);
      document.removeEventListener('touchcancel', this.dragEnd);
    }

    addGlobalEvents(isTouch) {
      const events = isTouch 
        ? [['touchmove', this.dragMove, {passive: false}], ['touchend', this.dragEnd], ['touchcancel', this.dragEnd]]
        : [['mousemove', this.dragMove], ['mouseup', this.dragEnd], ['mouseleave', this.dragEnd]];
      
      events.forEach(([event, handler, options]) => 
        document.addEventListener(event, handler, options));
    }

    setupObservers() {
      const { slider } = this.els;

      // Dynamic content changes
      if (this.dataset.dummy === "true") {
        this.addObserver(new MutationObserver(() => this.initSlider()), 
          slider, { childList: true });
      }
      
      // Visibility observer
      const visibilityObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.initSlider();
          visibilityObserver.unobserve(slider);
        }
      });
      
      this.addObserver(visibilityObserver, slider);
      
      // Attribute observer for dynamic drag toggle
      const attributeObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-drag') {
            this.handleDragAttributeChange();
          }
        });
      });
      
      attributeObserver.observe(this, { attributes: true, attributeFilter: ['data-drag'] });
      this.observers.push({ observer: attributeObserver, target: this, options: { attributes: true, attributeFilter: ['data-drag'] } });
    }
    
    addObserver(observer, target, options = {}) {
      observer.observe(target, options);
      this.observers.push({ observer, target, options });
    }
    
    /**
     * Handle dynamic changes to the data-drag attribute
     * @private
     */
    handleDragAttributeChange() {
      const isDragDisabled = this.dataset.drag === "false";
      
      // Reset drag state when drag is disabled
      if (isDragDisabled) {
        this.state.wasDragged = false;
        this.state.isDragging = false;
        
        // Clean up any active drag operations
        this.cleanUpGlobalEvents();
      }
      
      // Update cursor style for slider bar
      if (this.els.sliderBar) {
        this.els.sliderBar.style.cursor = isDragDisabled ? 'default' : 'grab';
      }
    }
    
    createObserver(callback, options = {}) {
      return new IntersectionObserver(callback, options);
    }
    
    disconnectObservers() {
      this.observers.forEach(({ observer }) => observer.disconnect());
      this.observers = [];
    }

    initSlider() {
      const { slider, sliderBar, dots, thumbnails } = this.els;

      // attempts to check if slider is loaded late
      if (!slider.clientWidth) {
        let attempts = 0;
        const maxAttempts = 10;
        
        const tryInit = () => {
          if (attempts >= maxAttempts) return;
          attempts++;
          
          setTimeout(() => {
            if (!slider.clientWidth) {
              tryInit();
            } else {
              this.initSlider();
            }
          }, 100);
        };
        
        tryInit();
        return;
      }

      // Resize observer
      this.addObserver(new ResizeObserver(() => {
        requestAnimationFrame(() => this.updateUI());
      }), slider);
      
      // Cache slider items
      this.items = slider.querySelector("electric-feed > *.contents") 
        ? this.querySelectorAll("electric-feed .contents > *") 
        : this.querySelectorAll("electric-feed > *");
      
      if (!this.items.length) return;

      // Find first and last visible elements
      this.firstEl = [...this.items].find(item => item.clientWidth > 0);
      this.lastEl = [...this.items].reverse().find(item => item.clientWidth > 0);
      
      if (!this.firstEl || !this.lastEl) return;

      if (sliderBar) {
        console.log(sliderBar)
        sliderBar.parentElement.style.setProperty('--slider-bar-position', '0px');
        sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', '0px');
      }
            
      this.currentIndex = 0;

      if (dots) {
        [...dots.children].forEach((dot, index) => {
          dot.dataset.active = index === 0 ? 'true' : 'false';
          this.addEvent(dot, 'click', () => this.navigateSlider(index));
        });
      }

      if (thumbnails) {
        [...thumbnails.children].forEach((thumbnail, index) => {
          thumbnail.dataset.active = index === 0 ? 'true' : 'false';
          this.addEvent(thumbnail, 'click', () => this.navigateSlider(index));
        });
      }

      // Set up carousel modes
      this.setupSliderMode();

      // Setup edge detection
      this.setupEdgeDetection();
      
      // Initialize UI state
      this.updateUI();
    }
    
    setupSliderMode() {
      if (this.dataset.carouselMode === "fade") {
        this.setupFadeMode();
      } else if (this.dataset.carouselMode === "slide") {
        this.setupSlideMode();
      }
    }
    
    setupEdgeDetection() {
      const { slider } = this.els;
      const options = { threshold: 1, root: slider };
      
      this.startObserver = this.createObserver(entries => {
        this.els.prevBtn?.toggleAttribute("disabled", entries[0].isIntersecting);
        this.updateNavVisibility();
      }, options);
      
      this.endObserver = this.createObserver(entries => {
        this.els.nextBtn?.toggleAttribute("disabled", entries[0].isIntersecting);
        this.updateNavVisibility();
      }, options);
      
      // Observer to manage activation
      this.elementObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting) {
          this.startObserver.observe(this.firstEl);
          this.endObserver.observe(this.lastEl);
        } else {
          this.startObserver.unobserve(this.firstEl);
          this.endObserver.unobserve(this.lastEl);
        }
      }, { threshold: 0.1 });
      
      this.elementObserver.observe(slider);
    }
    
    setupFadeMode() {
      const { slider } = this.els;
      
      slider.style.position = 'relative';
      slider.style.overflow = 'hidden';
      
      this.items.forEach(item => {
        item.style.position = 'absolute';
        item.style.inset = '0';
      });
    }
    
    setupSlideMode() {
      const { slider, sliderBar } = this.els;
      
      // Clone the first element and add it as the last item to create an infinite loop effect
      const clonedFirstElement = this.firstEl.cloneNode(true);
      clonedFirstElement.classList.add('cloned-slide');
      slider.appendChild(clonedFirstElement);
      
      // Set up intersection observer to detect when the clone is in view
      const firstCloneObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting && !this.state.isTransitioning) {
          this.state.isTransitioning = true;
          slider.scrollTo({ left: slider.clientWidth, behavior: 'instant' });
          setTimeout(() => { this.state.isTransitioning = false; }, 50);
        }
      }, { threshold: 1.0, root: slider });
      
      firstCloneObserver.observe(clonedFirstElement);
      this.observers.push({ observer: firstCloneObserver, target: clonedFirstElement, options: { threshold: 1.0, root: slider } });

      // Clone the last element and add it as the first item
      const clonedLastElement = this.lastEl.cloneNode(true);
      clonedLastElement.classList.add('cloned-slide');
      slider.insertBefore(clonedLastElement, slider.firstChild);
      slider.scrollTo({ left: slider.clientWidth, behavior: 'instant' });

      const lastCloneObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting && !this.state.isTransitioning) {
          this.state.isTransitioning = true;
          slider.scrollTo({ left: slider.scrollWidth - (2 * slider.clientWidth), behavior: 'instant' });
          setTimeout(() => { this.state.isTransitioning = false; }, 50);
        }
      }, { threshold: 1.0, root: slider });
      
      lastCloneObserver.observe(clonedLastElement);
      this.observers.push({ observer: lastCloneObserver, target: clonedLastElement, options: { threshold: 1.0, root: slider } });

      if (sliderBar) {
        this.cloneSliderBar = sliderBar.cloneNode(true);
        this.cloneSliderBar.style.transform = `translateX(calc(var(--slider-bar-clone-position) - var(--slider-bar-width)))`;
        this.cloneSliderBar.style.willChange = 'transform';
        sliderBar.parentElement.appendChild(this.cloneSliderBar);
      }
    }

    updateUI() {
      this.updateGradient();
      this.updateScrollability();
      this.updateSliderBar();
      debounce(this.updateSliderBarCSS.bind(this), 200)();
    }

    updateGradient() {
      const { gradient, slider } = this.els;
      
      if (gradient && this.items?.[0]) {
        const height = this.items[0].clientHeight || 0;
        slider.style.setProperty("--gradient-height", `${height}px`);
      }
    }

    updateScrollability() {
      const { slider, nav, sliderBar, dots, thumbnails, prevBtn, nextBtn } = this.els;
      const isHidden = this.dataset.carouselMode === "fade" ? this.items.length <= 1 : slider.scrollWidth <= slider.clientWidth;
      nav?.classList.toggle("hidden", isHidden);
      sliderBar?.parentElement?.classList.toggle("hidden", isHidden);
      dots?.classList.toggle("hidden", isHidden);
      thumbnails?.classList.toggle("hidden", isHidden);
      prevBtn?.classList.toggle("hidden", isHidden);
      nextBtn?.classList.toggle("hidden", isHidden);
    }

    updateNavVisibility() {
      const { prevBtn, nextBtn, prevWrapper, sliderBar } = this.els;
      
      if (!prevBtn || !nextBtn) return;
      
      const isHidden = prevBtn.hasAttribute("disabled") && nextBtn.hasAttribute("disabled");
      prevWrapper?.classList.toggle("opacity-0", isHidden);
    }

    handleWheel(e) {
      if (this.dataset.carouselMode !== "fade" || 
          Math.abs(e.deltaX) <= Math.abs(e.deltaY) || 
          Math.abs(e.deltaX) < 1 ||
          this.state.isTransitioning || 
          (Date.now() - this.state.lastWheelTime) < 200) return;
      
      e.preventDefault();
      
      this.state.lastWheelTime = Date.now();
      this.state.isTransitioning = true;
      
      const direction = e.deltaX > 0 ? 1 : -1;
      this.navigateSlider(this.currentIndex + direction);
      
      setTimeout(() => { this.state.isTransitioning = false; }, 800);
    }

    //amk currentindexi ilk basta set olamiyor dataset active falan olmadigi icin
    get currentIndex() {
      return [...this.items].findIndex(item => item.dataset.active === 'true') || 0;
    }

    set currentIndex(index) {
      this.items.forEach(item => item.dataset.active = 'false');
      this.items[index].dataset.active = 'true';
      this.updateNavs(index)
    }

    updateNavs(targetIndex) {
      // Update dots
      if (this.els.dots) {
        const dots = [...this.els.dots.children];
        dots.forEach(dot => dot.dataset.active = 'false');
        dots[targetIndex].dataset.active = 'true';
      }

      // Update thumbnails
      if (this.els.thumbnails) {
        const thumbnails = [...this.els.thumbnails.children];
        thumbnails.forEach(thumbnail => thumbnail.dataset.active = 'false');
        thumbnails[targetIndex].dataset.active = 'true';
      }

      this.updateSliderBar()
    }

    handleDirectionClick(event) {
      event.preventDefault();
      const { slider } = this.els;
      const { clientWidth } = this.values;
      const direction = event.currentTarget.name === "next" ? 1 : -1;
      const step = this.dataset.sliderStepBy === "page" 
      ? clientWidth || 0
      : this.firstEl?.clientWidth || 0;

      if(step) {
        slider.scrollTo({
          left: slider.scrollLeft + (direction * step),
          behavior: 'smooth'
        });
      }
    }

    navigateSlider(index, behavior = 'smooth') {
      const { slider } = this.els;
      const { clientWidth } = this.values;
      
      if (this.dataset.carouselMode === "fade") {
        const totalSlides = this.items.length;
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
      } else {
        const step = this.dataset.sliderStepBy === "page" 
          ? clientWidth || 0
          : this.firstEl?.clientWidth || 0;
          
        if (step) {
          slider.scrollTo({
            left: (index + (this.dataset.carouselMode === "slide" ? 1 : 0)) * step,
            behavior: behavior
          });
        }
      }

      this.currentIndex = index;
    }

    shouldStartDrag(e) {
      const isTouchEvent = e.type.includes('touch');
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { slider } = this.els;
      
      // Store initial position
      this.state.initialPos = {
        left: slider.scrollLeft,
        x: clientX
      };
      
      return true;
    }

    startDrag(e, preventDefault = true) {
      if (this.state.isDragging) return;
      
      const isTouchEvent = e.type.includes('touch');
      // Return early if it's a touch event but not in carousel mode
      if (isTouchEvent && !this.dataset.carouselMode) return;
      
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { slider } = this.els;
      
      this.state = {
        ...this.state,
        isDragging: true,
        wasDragged: false,
        pos: {
          left: slider.scrollLeft,
          x: clientX
        }
      };
      
      // Disable smooth scrolling during drag
      slider.style.scrollBehavior = "auto";
      slider.style.scrollSnapType = "none";
      
      this.addGlobalEvents(isTouchEvent);
    }

    dragMove(e) {
      if (!this.state.isDragging) return;
      
      const isTouchEvent = e.type.includes('touch');
      if (isTouchEvent) {
        // Check if we've moved enough to consider this a drag
        const touch = e.touches[0];
        const dx = Math.abs(touch.clientX - this.state.initialTouch.x);
        const dy = Math.abs(touch.clientY - this.state.initialTouch.y);
        const timeDiff = Date.now() - this.state.initialTouch.time;
        
        // If we've moved enough horizontally and not too much vertically, prevent default
        if (dx > 10 && dy < 20 && timeDiff < 300) {
          e.preventDefault();
        }
      }
      
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { pos, dragThreshold } = this.state;
      const dx = clientX - pos.x;
      
      if (Math.abs(dx) <= dragThreshold) {
        return;
      }
      this.state.wasDragged = true;
      
      if (this.dataset.carouselMode === "fade") {
        this.dragDistance = dx;
        return;
      }
      
      const { slider } = this.els;
      slider.scrollLeft = pos.left - dx;
      this.updateSliderBar();
    }

    dragEnd() {
      if (!this.state.isDragging) return;
      
      this.state.isDragging = false;
      
      // Remove all event listeners
      this.cleanUpGlobalEvents();
      
      const { slider } = this.els;
      
      if (this.dataset.carouselMode === "fade") {
        if (Math.abs(this.dragDistance) > this.state.dragThreshold) {
          const direction = this.dragDistance < 0 ? 1 : -1;
          this.navigateSlider(this.currentIndex + direction);
        }
        this.dragDistance = 0;
        return;
      }

      if (!this.state.wasDragged) return;
      
      const direction = slider.scrollLeft > this.state.pos.left ? "right" : "left";
      const target = this.findSnapPoint({
        currentScrollLeft: slider.scrollLeft,
        dragDirection: direction,
        by: 'page'
      });
      
      slider.scrollTo({ left: target, behavior: 'smooth' });
      slider.addEventListener('wheel', this.resetScrollSnap);
    }

    resetScrollSnap() {
      setTimeout(() => {
        const { slider } = this.els;
        slider.style.scrollSnapType = "x mandatory";
        slider.style.scrollBehavior = "smooth";
        slider.removeEventListener('wheel', this.resetScrollSnap);
      }, 100);
    }

    startBarDrag(e) {
      e.preventDefault();
      const { slider, sliderBar } = this.els;
      const isTouch = e.type.includes('touch');
      const { clientWidth, handleWidth, scrollable } = this.values;
      
      this.state.isDragging = true;
      sliderBar.style.cursor = 'grabbing';
      slider.style.scrollBehavior = "auto";
      slider.style.scrollSnapType = "none";
      
      const trackRect = sliderBar.parentElement.getBoundingClientRect();
      const startScrollLeft = slider.scrollLeft;
      const handleRect = sliderBar.getBoundingClientRect();
      const handleOffset = (isTouch ? e.touches[0].clientX : e.clientX) - handleRect.left;

      const moveHandler = (e) => {
        if (!this.state.isDragging) return;
        
        const cursorX = (e.touches ? e.touches[0].clientX : e.clientX);
        const cursorPosition = cursorX - trackRect.left - handleOffset;
        const effectiveWidth = trackRect.width - (trackRect.width * handleWidth);
        const progress = Math.max(0, Math.min(1, cursorPosition / effectiveWidth));

        slider.scrollLeft = progress * scrollable + (this.dataset.carouselMode === "slide" ? clientWidth : 0)
        
        this.updateSliderBar();
      };

      const stopHandler = () => {
        if (!this.state.isDragging) return;
        
        this.state.isDragging = false;
        sliderBar.style.cursor = 'grab';
        
        const direction = slider.scrollLeft < startScrollLeft ? "left" : "right";
        const target = this.findSnapPoint({
          currentScrollLeft: slider.scrollLeft,
          dragDirection: direction,
          by: 'item'
        });

        slider.scrollTo({ left: target, behavior: 'smooth' });
        
        slider.addEventListener('wheel', this.resetScrollSnap);
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', stopHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', stopHandler);
        document.removeEventListener('touchcancel', stopHandler);

        this.resetScrollSnap();
      };

      // Add appropriate event listeners
      if (isTouch) {
        document.addEventListener('touchmove', moveHandler, { passive: false });
        document.addEventListener('touchend', stopHandler);
        document.addEventListener('touchcancel', stopHandler);
      } else {
        document.addEventListener('mousemove', moveHandler);
        document.addEventListener('mouseup', stopHandler);
      }
    }

    findSnapPoint({currentScrollLeft, dragDirection, by = 'page' }) {
      const { slider } = this.els;
      let targetScrollLeft = currentScrollLeft;
      let closestDiff = Infinity;
      
      const padding = parseInt(getComputedStyle(slider).scrollPaddingLeft) || 0;
      const gap = parseInt(getComputedStyle(slider).gap) || 0;
      
      if (by === 'item') {
        for (const item of slider.children) {
          const itemLeft = item.offsetLeft - padding;
          const diff = itemLeft - currentScrollLeft;
          const absDiff = Math.abs(diff);
          
          if ((dragDirection === "right" && diff >= 0) || 
              (dragDirection === "left" && diff <= 0) || 
              diff === 0) {
            if (absDiff < closestDiff) {
              closestDiff = absDiff;
              targetScrollLeft = itemLeft;
            }
          }
        }
      } else if (by === 'page') {
        const times = currentScrollLeft / slider.clientWidth;
        targetScrollLeft = (slider.clientWidth - padding - padding + gap) * (dragDirection === "right" ? Math.ceil(times) : Math.floor(times))
      }

      return Math.max(0, Math.min(targetScrollLeft, slider.scrollWidth - slider.clientWidth));
    }

    get values() {
      const { slider } = this.els;
      const scrollPaddingLeft = parseInt(getComputedStyle(slider).scrollPaddingLeft) || 0;
      const scrollPaddingRight = parseInt(getComputedStyle(slider).scrollPaddingRight) || 0;
      const paddingRight = parseInt(getComputedStyle(slider).paddingRight) || 0;
      const paddingLeft = parseInt(getComputedStyle(slider).paddingLeft) || 0;
      const gap = parseInt(getComputedStyle(slider).gap) || 0;
      const totalPadding = scrollPaddingLeft + scrollPaddingRight + paddingRight + paddingLeft;
      const clientWidth = slider.clientWidth - totalPadding + gap;
      const scrollWidth = this.dataset.carouselMode === "slide" 
        ? slider.scrollWidth - (2 * clientWidth) - totalPadding 
        : slider.scrollWidth - totalPadding;
      const handleWidth = clientWidth / scrollWidth;
      const barWidth = clientWidth * handleWidth;
      const scrollable = scrollWidth - clientWidth;

      return {
        scrollPaddingLeft,
        scrollPaddingRight,
        clientWidth,
        scrollWidth,
        handleWidth,
        barWidth,
        scrollable
      };
    }

    updateSliderBarCSS() {
      const { sliderBar } = this.els;
      sliderBar?.parentElement?.style.setProperty('--slider-bar-width', `${this.values.barWidth}px`);
    }

    throttleUpdate() {
      requestAnimationFrame(() => this.updateSliderBar());
    }

    updateSliderBar() {
      const { slider, sliderBar } = this.els;
      if (!sliderBar || slider.scrollWidth === 0) return;

      const { barWidth, scrollable, clientWidth } = this.values;
    
      const progress = scrollable > 0 ? (slider.scrollLeft - (this.dataset.carouselMode === "slide" ? clientWidth : 0)) / scrollable : 0;
      const position = progress >= 1 + (clientWidth / scrollable) ? 0 : progress * (clientWidth - barWidth);

      sliderBar.parentElement.style.setProperty('--slider-bar-position', `${position}px`);
      
      if (this.dataset.carouselMode === "slide") {
        if (progress > 1 || progress < 0) {
          sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', `${barWidth + position + (progress > 1 ? -clientWidth : clientWidth)}px`);
        } else {
          setTimeout(() => {
            sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', `-${barWidth}px`);
          }, 100);
        }
      }
    }
  }

  customElements.define("electric-slider", SnapSlider);
}
if (!customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.state = {
        isPlaying: false,
        isPaused: false,
        isLoading: false,
      };
    }
    connectedCallback() {
      this.template = this.querySelector("template");
      this.button = this.querySelector("._playButton");
      this.setVideoState('idle'); // Initialize state
      this.loaders();
      this.setIframeAspectRatio();
      this.initializeVideoControls();
      this.initializePlayButtonControls();
    }

    // ADD THIS NEW METHOD
    initializePlayButtonControls() {
      const playButton = this.querySelector('.video-control-btn');
      if (!playButton) return;
      playButton.removeEventListener('click', this.initialPlayButtonClickHandler);

      this.initialPlayButtonClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.load();
        setTimeout(() => {
          const video = this.querySelector('video');
          if (video) {
            this.setVideoState('loading');
            video.play().then(() => {
              this.setVideoState('playing');
            }).catch(error => {
              console.warn('Video autoplay failed:', error);
              this.setVideoState('ready');
            });
          }
        }, 100);
      };
      playButton.addEventListener('click', this.initialPlayButtonClickHandler);
    }

    loaders() {
      if (!this.template) return;
      if (this.button) {
        this.button.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.load();
          // After loading, find the video and play it
          setTimeout(() => {
            const video = this.querySelector('video');
            if (video) {
              this.setVideoState('loading');
              video.play().then(() => {
                this.setVideoState('playing');
              }).catch(error => {
                console.warn('Video autoplay failed:', error);
                this.setVideoState('ready');
              });
            }
          }, 100);
        });
        return;
      }
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.load();
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0, rootMargin: "400px" },
      );
      observer.observe(this);
    }

    load() {
      if (this.button) {
        this.style.height = this.getBoundingClientRect().height + "px";
        this.style.width = this.getBoundingClientRect().width + "px";
        this.stopAllVideos();
      }
      this.appendChild(this.template.content.cloneNode(true));
      this.button?.classList.add("hidden");

      // Re-initialize video controls for newly loaded videos
      this.initializeVideoControls();

      setTimeout(() => {
        this.style.height = "";
        this.style.width = "";
      }, 1000);
    }

    initializeVideoControls() {
      // Find all video elements within this video player
      const videos = this.querySelectorAll('video');
      
      videos.forEach(video => {
        this.setupVideoControls(video);
      });
    }

    setupVideoControls(video) {
      const playButton = this.querySelector('.video-control-btn');
      if (!playButton) return;

      // Remove existing event listeners to prevent duplicates
      this.removeEventListener('click', this.videoPlayerClickHandler);
      playButton.removeEventListener('click', this.playButtonClickHandler);

      // Create bound methods for event handlers
      this.videoPlayerClickHandler = (e) => {
        if (e.target.closest('.group')) return;
        this.toggleVideoPlayback(video);
      };

      this.playButtonClickHandler = (e) => {
        e.stopPropagation(); // Prevent player click handler
        this.toggleVideoPlayback(video);
      };

      // Click handler for the video player (excluding the group button)
      this.addEventListener('click', this.videoPlayerClickHandler);

      // Click handler for play button
      playButton.addEventListener('click', this.playButtonClickHandler);

      // Remove existing keyboard event listeners to prevent duplicates
      playButton.removeEventListener('keydown', this.playButtonKeydownHandler);
      video.removeEventListener('keydown', this.videoKeydownHandler);

      // Create bound methods for keyboard event handlers
      this.playButtonKeydownHandler = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          this.toggleVideoPlayback(video);
        }
      };

      this.videoKeydownHandler = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleVideoPlayback(video);
        }
      };

      // Keyboard accessibility for play button
      playButton.addEventListener('keydown', this.playButtonKeydownHandler);

      // Keyboard accessibility for video element
      video.addEventListener('keydown', this.videoKeydownHandler);

      // Create bound methods for video event handlers
      this.videoPlayHandler = () => {
        this.setVideoState('playing');
      };

      this.videoPauseHandler = () => {
        this.setVideoState('paused');
      };

      this.videoErrorHandler = (e) => {
        console.error('Video error:', e);
        this.setVideoState('error');
        const playButton = this.querySelector('.video-control-btn');
        if (playButton) {
          playButton.disabled = true;
          playButton.style.opacity = '0.5';
        }
      };

      this.videoLoadstartHandler = () => {
        this.setVideoState('loading');
        if (playButton) {
          playButton.disabled = false;
          playButton.style.opacity = '1';
        }
      };

      this.videoCanplayHandler = () => {
        this.setVideoState('ready');
      };

      this.videoEndedHandler = () => {
        this.setVideoState('ended');
      };

      // Video event listeners with error handling
      video.addEventListener('play', this.videoPlayHandler);
      video.addEventListener('pause', this.videoPauseHandler);
      video.addEventListener('error', this.videoErrorHandler);
      video.addEventListener('loadstart', this.videoLoadstartHandler);
      video.addEventListener('canplay', this.videoCanplayHandler);
      video.addEventListener('ended', this.videoEndedHandler);
    }

    // Function to safely toggle video playback with error handling
    toggleVideoPlayback(video) {
      try {
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.warn('Video play failed:', error);
            });
          }
        } else {
          video.pause();
        }
      } catch (error) {
        console.error('Error toggling video playback:', error);
      }
    }


    // Function to set video player state
    setVideoState(state) {
      this.setAttribute('data-state', state);
    }

    stopAllVideos() {
      const videos = document.querySelectorAll("video");
      videos.forEach((video) => {
        if (video !== this.querySelector("video") && !video.autoplay) {
          video.pause();
        }
      });

      const iframes = document.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        if (iframe !== this.querySelector("iframe")) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: "command", func: "pauseVideo" }),
            "*",
          );
        }
      });
    }
    async setIframeAspectRatio() {
      if (!this.template) return;
      const iframe = this.template.content.querySelector("iframe");
      if (!iframe) return;
      if (iframe.src.includes("youtube")) return;
      const { width, height } = await this.getIframeWidthHeight(iframe);
      iframe.style.aspectRatio = `${width}/${height}`;
      if (this.querySelector("iframe")) {
        this.querySelector("iframe").style.aspectRatio = `${width}/${height}`;
        this.style.setProperty("--aspect-ratio", `${width} / ${height}`);
      }
    }
    async getIframeWidthHeight(iframe) {
      let url = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${iframe.dataset.videoId}`;
      const { width, height } = await fetch(url).then((resp) => resp.json());
      return { width, height };
    }

    disconnectedCallback() {
      // Clean up event listeners to prevent memory leaks and duplicate handlers
      if (this.videoPlayerClickHandler) {
        this.removeEventListener('click', this.videoPlayerClickHandler);
      }
      
      if (this.playButtonClickHandler) {
        const playButton = this.querySelector('.video-control-btn');
        if (playButton) {
          playButton.removeEventListener('click', this.playButtonClickHandler);
        }
      }
      
      if (this.playButtonKeydownHandler) {
        const playButton = this.querySelector('.video-control-btn');
        if (playButton) {
          playButton.removeEventListener('keydown', this.playButtonKeydownHandler);
        }
      }
      
      if (this.videoKeydownHandler) {
        const videos = this.querySelectorAll('video');
        videos.forEach(video => {
          video.removeEventListener('keydown', this.videoKeydownHandler);
        });
      }
      
      // Clean up video event listeners
      const videos = this.querySelectorAll('video');
      videos.forEach(video => {
        if (this.videoPlayHandler) video.removeEventListener('play', this.videoPlayHandler);
        if (this.videoPauseHandler) video.removeEventListener('pause', this.videoPauseHandler);
        if (this.videoErrorHandler) video.removeEventListener('error', this.videoErrorHandler);
        if (this.videoLoadstartHandler) video.removeEventListener('loadstart', this.videoLoadstartHandler);
        if (this.videoCanplayHandler) video.removeEventListener('canplay', this.videoCanplayHandler);
        if (this.videoEndedHandler) video.removeEventListener('ended', this.videoEndedHandler);
      });
    }
  }
  customElements.define("video-player", VideoPlayer);
}
if (!customElements.get("pagination-element")) {
  class PaginationElement extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute("data-section-fetcher-target")) return;
      this.sectionFetcherTarget = document.getElementById(
        this.dataset.sectionFetcherTarget,
      );
      this.querySelectorAll("a").forEach((link) => {
        // create new href from a href with sectionFetcherTarget's data-section-id value as a parameter to query key section_id
        const newHref = new URL(link.href);
        newHref.searchParams.set(
          "section_id",
          this.sectionFetcherTarget.dataset.sectionId,
        );
        link.href = newHref.toString();
      });
      delegate(this, "click", "a", this.onLinkClicked.bind(this));
      window.addEventListener("popstate", (event) => {
        this.handlePopState(event);
      });
    }

    handlePopState(event) {
      const page = event.state && event.state.page ? event.state.page : "1";

      const target = this.querySelector(`a[data-page="${page}"]`);

      if (target) {
        this.onLinkClicked(new Event("click"), target, true);
      }
    }

    onLinkClicked(event, target, isPopState = false) {
      event.preventDefault();

      const page = target.getAttribute("data-page");
      const searchParams = new URLSearchParams(window.location.search);
      target.style.position =
        getComputedStyle(target).position === "absolute" ? "" : "relative";
      target.innerHTML += window.icons.spinner;

      if (page === "1") {
        searchParams.delete("page");
      } else {
        searchParams.set("page", page);
      }

      const newUrl = `${window.location.pathname}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;

      // if isPopState is false and the section fetcher url is the same with our current url, push a new state
      // this is to prevent pushing a new url state if we are on homepage etc.
      const targetPath = getPathWithoutQuery(
        this.sectionFetcherTarget.dataset.url,
      );
      const currentPath = getPathWithoutQuery(window.location.href);
      if (!isPopState && targetPath === currentPath) {
        window.history.pushState({ page: page }, "", newUrl);
      }

      triggerEvent(this, "pagination:page-changed", {
        searchParams: searchParams.toString(),
        sectionFetcherTarget: this.sectionFetcherTarget.id,
      });

      this.sectionFetcherTarget.dataset.skeletonItems =
        target.dataset.nextItems;
      this.sectionFetcherTarget.dataset.url = `${targetPath}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;
    }

    // updateFeed(target) {
    //   const feedFetcher = document.createElement("feed-fetcher");
    //   feedFetcher.dataset.url = target.href;
    //   const parent =
    //     this.closest("feed-fetcher") || this.closest(".js-feed-block");
    //   feedFetcher.style.height = parent.clientHeight + "px";
    //   feedFetcher.style.setProperty("--next-items", target.dataset.nextItems);
    //   feedFetcher.style.setProperty(
    //     "--product-card-height",
    //     parent.querySelector("product-card").clientHeight
    //   );
    //   feedFetcher.style.opacity = 0;

    //   parent.scrollIntoView({ behavior: "smooth" });

    //   parent.animate([{ opacity: 1 }, { opacity: 0 }], {
    //     duration: 150,
    //     easing: "ease-in-out",
    //     fill: "forwards",
    //   });

    //   parent.after(feedFetcher);
    //   parent.remove();

    //   feedFetcher.animate([{ opacity: 0 }, { opacity: 1 }], {
    //     duration: 150,
    //     easing: "ease-in-out",
    //     fill: "forwards",
    //   });
    // }
  }

  window.customElements.define("pagination-element", PaginationElement);
}
// Convert the bg color to rgba format with specific opacity
function setOpacity(color, opacity) {
  // Handle hex colors without # prefix
  if (/^[0-9a-fA-F]{6}$/.test(color) || /^[0-9a-fA-F]{3}$/.test(color)) {
    color = '#' + color;
  }

  // If already OKLCH, just update opacity
  if (color.startsWith("oklch")) {
    return color.replace(/\/\s*[\d.]+/, ` / ${opacity}`);
  }

  // Convert to RGB via computed style
  const tempDiv = document.createElement("div");
  tempDiv.style.color = color;
  document.body.appendChild(tempDiv);
  const rgbColor = getComputedStyle(tempDiv).color;
  tempDiv.remove();

  // Extract RGB values and return RGBA
  const rgbMatch = rgbColor.match(/\d+/g);
  if (rgbMatch && rgbMatch.length >= 3) {
    const [r, g, b] = rgbMatch.map(Number);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // Fallback
  return `rgba(0, 0, 0, ${opacity})`;
}
class GradientFinish extends HTMLElement {
  connectedCallback() {
    // reduce opacity when scroll of parent reaches end, parent could be vertical or horizontal scroll
    this.slider = document.querySelector(
      `[data-slider="${this.dataset.sliderTarget}"]`,
    );
    // find parent that has a class starting with bg-
    if (!this.slider) {
      this.remove();
      return;
    }

    // initial adjustment
    this.adjustColor();

    document.addEventListener('DOMContentLoaded', () => {
      // initial adjustment
      this.adjustOpacity()
      // adjust opacity on slider resize
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this.slider) {
            this.adjustOpacity()
          }
        }
      });
      resizeObserver.observe(this.slider);
    })


    // adjust opacity on scroll
    this.slider.addEventListener(
      "scroll",
      this.adjustOpacity.bind(this),
    );

    // adjust opacity on resize
    window.addEventListener(
      "resize",
      debounce(this.adjustOpacity.bind(this), 100),
    );
    // adjust opacity on resize
    window.addEventListener(
      "resize",
      debounce(this.adjustColor.bind(this), 400),
    );
  }

  adjustColor() {
    let bgParentWithStyle = this.parentElement.closest("[class*='bg-']");
    if (
      bgParentWithStyle &&
      getComputedStyle(bgParentWithStyle).backgroundColor === "rgba(0, 0, 0, 0)"
    ) {
      bgParentWithStyle =
        bgParentWithStyle.parentElement.closest("[class*='bg-']");
    }
    let bg = bgParentWithStyle
      ? getComputedStyle(bgParentWithStyle).backgroundColor
      : "white";
    this.style.setProperty("--from-bg", setOpacity(bg, 0.0));
    this.style.setProperty("--to-bg", setOpacity(bg, 1));
  }

  adjustOpacity() {
    const isVertical = this.slider.scrollHeight > this.slider.clientHeight;
    const isHorizontal = this.slider.scrollWidth > this.slider.clientWidth;

    let ratio = 1;

    if (isVertical) {
      const scrollEnd = this.slider.scrollHeight - this.slider.clientHeight;
      ratio = scrollEnd > 0 ? this.slider.scrollTop / scrollEnd : 1;
    } else if (isHorizontal) {
      const scrollEnd = this.slider.scrollWidth - this.slider.clientWidth;
      ratio = scrollEnd > 0 ? this.slider.scrollLeft / scrollEnd : 1;
    }

    this.style.opacity = ratio == 1 ? 0 : 1
  }
}
customElements.define("gradient-finish", GradientFinish);


class ProductCard extends HTMLElement {
  connectedCallback() {
    let image = this.querySelector("img.js-lazyloadBlur");
    let placeholder = this.querySelector(".js-lazyloadBlurPlaceholder");
    if (!placeholder) return;
    if (image.complete) {
      placeholder.style.opacity = 0;
      setTimeout(() => {
        placeholder.remove();
      }, 100);
      return;
    }
    image.addEventListener("load", () => {
      placeholder.style.opacity = 0;
      setTimeout(() => {
        placeholder.remove();
      }, 100);
    });
  }
}
customElements.define("product-card", ProductCard);

if (!customElements.get("scroll-top")) {
  customElements.define(
    "scroll-top",
    class extends HTMLElement {
      connectedCallback() {
        window.addEventListener("scroll", this.toggle.bind(this));
      }
      disconnectedCallback() {
        window.removeEventListener("scroll", this.toggle.bind(this));
      }
      toggle() {
        this.dataset.fadeIn = window.scrollY > 200 ? true : false;
      }
    },
  );
}
["DOMContentLoaded", "shopify:section:load"].forEach((event) => {
  document.addEventListener(event, () => {
    const firstSection = document.querySelector(
      "#MainContent .shopify-section:not(.shopify-section-group-header-group)",
    );
    const firstSectionMarginTop = parseInt(
      window.getComputedStyle(firstSection).marginTop,
    );
    document.body.style.setProperty(
      "--first-section-margin-top",
      `${firstSectionMarginTop}px`,
    );

    document.querySelectorAll("img.js-lazyloadBlur").forEach((image) => {
      let placeholder = image.nextElementSibling;
      if (!placeholder) return;
      if (image.complete) {
        placeholder.style.opacity = 0;
        setTimeout(() => {
          placeholder.remove();
        }, 400);
        return;
      }
      image.addEventListener("load", () => {
        placeholder.style.opacity = 0;
        setTimeout(() => {
          placeholder.remove();
        }, 400);
      });
    });
  });
});

function waitForScrollToEnd() {
  return new Promise((resolve) => {
    let scrollTimeout;
    let isScrolling = false;

    function handleScroll() {
      isScrolling = true;
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        resolve();
      }, 150); // Adjust this value to change the "scroll end" detection sensitivity
    }

    if (!isScrolling) {
      resolve();
    } else {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }
  });
}

function getPathWithoutQuery(url) {
  return new URL(url, window.location.origin).pathname;
}
function replaceNodeWithNodeList(nodeToReplace, nodeList) {
  if (!(nodeList instanceof NodeList) && !Array.isArray(nodeList)) {
    throw new Error("Second argument must be a NodeList or an array of nodes");
  }

  const parent = nodeToReplace.parentNode;
  if (!parent) {
    throw new Error("Cannot replace a node that is not in the DOM");
  }

  const fragment = document.createDocumentFragment();

  // If it's an array, we need to iterate differently
  if (Array.isArray(nodeList)) {
    nodeList.forEach((node) => fragment.appendChild(node));
  } else {
    // NodeList is array-like but not an array, so we use this method
    fragment.append(...nodeList);
  }

  parent.replaceChild(fragment, nodeToReplace);
}

function toggleButtonState(button, state) {
  switch (state) {
    case "loading":
      if (button.dataset.state == "loading") return;
      button.setAttribute("aria-disabled", true);
      button.dataset.state = "loading";
      break;

    case "error":
      button.dataset.state = "error";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;

    case "success":
      button.dataset.state = "success";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;
  }
}

function updateLabels() {
  const labels = document.querySelectorAll("drawer accordion-content label");
  labels.forEach((label) => {
    const attr = "drawer-" + label.getAttribute("for");
    const input = label.querySelector("input");
    if (input) input.setAttribute("id", attr);
    label.setAttribute("for", attr);
    label.control = input;
  });
}


// Define drawer-trigger custom element that connects to its target drawer
customElements.define(
  "drawer-trigger",
  class DrawerTrigger extends HTMLElement {
    connectedCallback() {
      // Get target drawer element
      const targetId = this.dataset.target;
      if (!targetId) return;
      
      const drawer = document.getElementById(targetId);
      if (!drawer) return;

      // Add this trigger to drawer's triggers array
      if (!drawer.triggers) drawer.triggers = new Set();
      drawer.triggers.add(this);

      // Handle click to toggle drawer
      this.addEventListener("click", () => {
        if (typeof drawer.toggleDrawer === "function") {
          drawer.toggleDrawer(this);
        }
      });
    }

    disconnectedCallback() {
      // Clean up by removing from drawer's triggers when removed
      const targetId = this.dataset.target;
      if (!targetId) return;
      
      const drawer = document.getElementById(targetId);
      if (drawer?.triggers) {
        drawer.triggers.delete(this);
      }
    }
  }
);
if (!customElements.get("drawer-element")) {
  customElements.define(
    "drawer-element",
    class DrawerElement extends HTMLElement {
      constructor() {
        super();
        this.drawer = this.querySelector("drawer");
        this.overlay = this.querySelector(".js-overlay");
        this.keepHeader = false;
        this.animationDuration =
          parseInt(this.dataset.animationDuration) || 700;

        this.bindEvents();
      }

      // Bind all event listeners
      bindEvents() {
        this.innerDrawerTitles = document.querySelectorAll(
          ".selected-inner-drawer",
        );

        // Add overlay click listener
        if (this.overlay) {
          this.overlay.addEventListener("click", () => this.closeDrawer());
        }

        // Add event listeners for keyup and focusout
        document.addEventListener("keyup", this.onKeyUp.bind(this));
        // this.addEventListener("focusout", this.onFocusOut.bind(this));
      }

      // Toggle drawer open/close
      toggleDrawer(trigger) {
        if (this.dataset.open === "true") {
          this.closeDrawer();
        } else {
          if (trigger.innerText) {
            this.innerDrawerTitles.forEach((title) => {
              title.innerText = trigger.innerText;
            });
          }
          this.openDrawer();
        }
      }

      // Handle keyup events
      onKeyUp(event) {
        if (
          event.code.toUpperCase() === "ESCAPE" &&
          this.dataset.open === "true"
        ) {
          this.closeDrawer();
        }
      }

      // Handle focus out events
      onFocusOut(event) {
        if (this.contains(event.relatedTarget)) return;
        setTimeout(() => {
          if (this.dataset.open === "true") this.closeDrawer();
        }, 0);
      }

      // Open the drawer
      openDrawer() {
        if (this.dataset.open === "true") return;

        this.handleScrollLock(true);
        this.dataset.open = "true";
        this.classList.remove("hidden");
        this.handleOverflowClasses("hidden");
        this.whenDrawerIsOpening();
        this.handleHeaderStickiness(false);
        trapFocus(this.drawer);

        this.openDrawerAnimation()
          .then(() => this.handleOverflowClasses("hidden"))
          .then(this.afterDrawerOpened.bind(this));
      }

      // Close the drawer
      closeDrawer() {
        if (this.dataset.open !== "true") return;

        this.dataset.open = "false";
        this.resetInnerDrawerTitles();
        this.whenDrawerIsClosing();
        this.handleScrollLock(false);
        this.handleOverflowClasses("scroll");
        removeTrapFocus(window);

        this.closeDrawerAnimation().then(() => {
          setTimeout(() => {
            this.classList.add("hidden");
            this.style.pointerEvents = "";
          }, 100);
          this.afterDrawerClosed();
        });
      }

      // Handle scroll locking
      handleScrollLock(lock) {
        if (
          this.dataset.lockScroll === "false" ||
          this.parentNode.closest("drawer-component")
        )
          return;

        const body = document.body;

        if (lock) {
          lockScrollForThis(this);
          this.style.pointerEvents = "";
          body.classList.add("overflow-hidden");
          if (this.keepHeader) {
            body.style.top = "0";
          }
        } else {
          unlockScrollForThis(this);
          body.classList.remove("overflow-hidden");
          body.style.top = "";
        }
      }

      // Handle overflow classes
      handleOverflowClasses(type) {
        const target =
          this.id === "cart-drawer"
            ? this.drawer
            : this.parentNode.closest("drawer-component")?.drawer;
        if (!target) return;

        target.classList.replace(
          `overflow-y-${type === "hidden" ? "scroll" : "hidden"}`,
          `overflow-y-${type}`,
        );
        target.classList.replace(
          `lg:overflow-y-${type === "hidden" ? "scroll" : "hidden"}`,
          `lg:overflow-y-${type}`,
        );
      }

      // Handle header stickiness
      handleHeaderStickiness(sticky) {
        const header = document.querySelector("header-element");
        if (header.header?.classList.contains("sticky") && !this.keepHeader) {
          header.header.classList.toggle("sticky", sticky);
        }
      }

      // Reset inner drawer titles
      resetInnerDrawerTitles() {
        this.innerDrawerTitles.forEach((title) => {
          title.innerText = "";
        });
      }

      // Animation for opening the drawer
      async openDrawerAnimation() {
        const { drawer, overlay } = this;
        const options = this.getAnimationOptions();

        this.prepareDrawerForAnimation(drawer);

        const drawerAnimation = drawer.animate(
          [{ transform: "translateX(150%)" }, { transform: "translateX(0)" }],
          options,
        );

        const overlayAnimation = overlay?.animate(
          [{ opacity: 0 }, { opacity: 0.7 }],
          options,
        );

        await Promise.all([
          drawerAnimation.finished,
          overlayAnimation?.finished,
        ]);

        drawer.style.transform = "";
        this.animation = overlayAnimation;

        return Promise.resolve();
      }

      // Animation for closing the drawer
      async closeDrawerAnimation() {
        this.style.pointerEvents = "none";
        const { drawer, overlay } = this;
        const options = this.getAnimationOptions();

        const drawerAnimation = drawer.animate(
          [{ transform: "translateX(0%)" }, { transform: "translateX(150%)" }],
          options,
        );

        const overlayAnimation = overlay?.animate(
          [{ opacity: 0.7 }, { opacity: 0 }],
          options,
        );

        await Promise.all([
          drawerAnimation.finished,
          overlayAnimation?.finished,
        ]);

        this.restoreDrawerClasses(drawer);
        this.animation?.cancel();

        return Promise.resolve();
      }

      // Get animation options
      getAnimationOptions() {
        return {
          duration: this.animationDuration,
          easing: "cubic-bezier(0.4, 0.0, 0.2, 1)",
          fill: "forwards",
        };
      }

      // Prepare drawer for animation
      prepareDrawerForAnimation(drawer) {
        if (drawer.dataset.removeToOpen) {
          drawer.classList.remove(...drawer.dataset.removeToOpen.split(" "));
        }
        drawer.style.transform = "translateX(150%)";
      }

      // Restore drawer classes after animation
      restoreDrawerClasses(drawer) {
        if (drawer.dataset.removeToOpen) {
          drawer.classList.add(...drawer.dataset.removeToOpen.split(" "));
        }
      }

      // Lifecycle hooks (to be overridden if needed)
      afterDrawerOpened() {}
      afterDrawerClosed() {}
      whenDrawerIsOpening() {}
      whenDrawerIsClosing() {}
    },
  );
}

function getVisibleHeight(element) {
  // Get the element's bounding rectangle
  const rect = element.getBoundingClientRect();

  // Get viewport height
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate top and bottom edges relative to viewport
  const elementTop = rect.top;
  const elementBottom = rect.bottom;

  // Element is completely above or below viewport
  if (elementTop >= viewportHeight || elementBottom <= 0) {
    return 0;
  }

  // Element is partially visible
  if (elementTop < 0) {
    // Element is clipped at top
    return Math.min(elementBottom, viewportHeight);
  }

  if (elementBottom > viewportHeight) {
    // Element is clipped at bottom
    return viewportHeight - elementTop;
  }

  // Element is fully visible
  return rect.height;
}
class LoadingBar extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("beforeunload", () => {
      this.animate({ opacity: [0, 1] }, { duration: 400 });
      document.body.classList.add("unloading");
    });

    window.addEventListener("DOMContentLoaded", () => {
      this.animate({ opacity: [1, 0] }, { duration: 400 }).onfinish = () => {
        this.style.visibility = "hidden";
      };

      document.body.classList.add("loaded");
      document.dispatchEvent(new CustomEvent("page:loaded"));
    });

    window.addEventListener("pageshow", (event) => {
      // Removes unload class when returning to page via history
      if (event.persisted) {
        document.body.classList.remove("unloading");
      }
    });
  }
}
customElements.define("loading-bar", LoadingBar);
class HeaderElement extends HTMLElement {
  static observedAttributes = ["data-sticky"];

  constructor() {
    super();
    this.state = {
      lastScrollTop: 0,
      isHidden: false,
      headerHeight: 0,
      announcementHeight: 0
    };

    this.config = {
      threshold: 0,
      slideDuration: 300,
      hiddenTransform: "translateY(-160px)",
    };

    this.observers = [];
  }

  connectedCallback() {
    this.setupDOMReferences();
    if (!this.isSticky || !this.header) return;

    this.setupHeaderOffset();
    this.setupHeaderStickyOffset();
    this.updateHeaderHeight();
    this.setupEventListeners();
    this.setupInitialStickyState();
  }

  disconnectedCallback() {
    if (!this.isSticky) return;
    this.removeEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-sticky") {
      this.isSticky = newValue === "true";
    }
  }

  setupDOMReferences() {
    this.header = this.closest(".header-elements");
    this.announcementBar = this.querySelector(".js-announcement-bar");
    this.isSticky = this.dataset.sticky === "true";
  }

  setupHeaderOffset() {
    const setHeaderOffset = () => {
      const headerElements = document.querySelectorAll("header-element");
      if (!headerElements.length) return;

      const headerHeight = [...headerElements].reduce(
        (acc, el) => acc + el.offsetHeight,
        0,
      );
      document.body.style.setProperty("--header-offset", `${headerHeight}px`);
    };

    setHeaderOffset();
    window.addEventListener("resize", setHeaderOffset);
  }

  setupHeaderStickyOffset() {
    const setStickyOffset = () => {
      setTimeout(() => {
        document.body.style.setProperty(
          "--header-sticky-offset",
          `${getVisibleHeight(this)}px`,
        );
      }, 500);
    };
    setStickyOffset();
    window.addEventListener("resize", setStickyOffset);
  }

  setupInitialStickyState() {
    this.headerOffset = document.createElement("div");
    this.headerOffset.style.height = `${this.state.headerHeight}px`;
    this.headerOffset.className =
      "absolute inset-0 bg-background1 shopify-section-group-header-group";
    this.headerOffset.setAttribute("aria-hidden", "true");
    // this.header.before(this.headerOffset);

    this.header.classList.add(
      "transition-top",
      "duration-300",
      "sticky",
      "z-1010",
      "-top-(--header-offset)",
      "bg-transparent",
    );
  }

  setupEventListeners() {
    this.handleScroll = this.handleScroll.bind(this);
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this);

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateHeaderHeight);
  }

  removeEventListeners() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateHeaderHeight);
  }

  updateHeaderHeight() {
    this.state.headerHeight = this.header.offsetHeight;
    this.state.announcementHeight = this.announcementBar?.offsetHeight ?? 0;
    if (this.headerOffset)
      this.headerOffset.style.height = `${this.state.headerHeight}px`;
  }

  handleScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.handleHeaderVisibility(scrollPosition);
  }

  handleHeaderVisibility(scrollPosition) {
    if (scrollPosition > this.config.threshold) {
      if (scrollPosition > this.state.lastScrollTop && !this.state.isHidden) {
        this.hideHeader();
      } else if (
        scrollPosition < this.state.lastScrollTop &&
        this.state.isHidden
      ) {
        this.showHeader();
      }
    } else if (scrollPosition <= this.state.announcementHeight) {
      this.resetHeaderPosition();
    } else if (this.state.isHidden) {
      this.showHeader();
    }

    this.state.lastScrollTop = scrollPosition;
  }

  hideHeader() {
    if (this.state.isHidden) return;
    this.resetHeaderPosition();
    this.state.isHidden = true;
    this.setupHeaderStickyOffset();
  }

  isMobile() {
    const mobileBreakpoints = ["xs", "sm", "md"];
    const currentBreakpoint = getCurrentBreakpoint();
    return mobileBreakpoints.includes(currentBreakpoint);
  }

  showHeader() {
    if (!this.state.isHidden) return;
    const isMobile = this.isMobile();
    this.header.style.top = isMobile
      ? `-${this.state.announcementHeight}px`
      : `-${this.state.announcementHeight}px`;
    this.state.isHidden = false;
    this.setupHeaderStickyOffset();
  }

  resetHeaderPosition() {
    if (this.header.style.top === "") return;
    this.header.style.top = "";
  }
}

customElements.define("header-element", HeaderElement);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"],input[name="locale_code"], input[name="country_code"]',
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

// fix childMenu positions
const fixChildMenuPositions = () => {
  const childMenus = document.querySelectorAll("._headerChildMenu");
  const isRTL = document.body.style.direction === "rtl";
  const windowWidth = window.innerWidth;

  childMenus.forEach((childMenu) => {
    let isOffScreen = false;
    const childMenuRect = childMenu.getBoundingClientRect();

    // Check if the child menu itself is off-screen
    if (isRTL) {
      isOffScreen = childMenuRect.left < 0;
    } else {
      isOffScreen = childMenuRect.right > windowWidth;
    }

    // If child menu is not off-screen, check its grandchild menus
    if (!isOffScreen) {
      const grandChildMenus = childMenu.querySelectorAll(
        "._headerGrandChildMenu",
      );
      grandChildMenus.forEach((grandChildMenu) => {
        // Temporarily make the grandchild menu visible for accurate measurements
        const originalDisplay = grandChildMenu.style.display;
        grandChildMenu.style.display = "block";
        grandChildMenu.style.visibility = "hidden";

        const grandChildMenuRect = grandChildMenu.getBoundingClientRect();

        // Restore original display
        grandChildMenu.style.display = originalDisplay;
        grandChildMenu.style.visibility = "";

        if (isRTL) {
          if (grandChildMenuRect.left < 0) isOffScreen = true;
        } else {
          if (grandChildMenuRect.right > windowWidth) isOffScreen = true;
        }
      });
    }

    if (isOffScreen) {
      childMenu.setAttribute("data-offscreen", "true");
    } else {
      childMenu.removeAttribute("data-offscreen");
    }
  });
};

window.addEventListener("resize", fixChildMenuPositions);
window.addEventListener("DOMContentLoaded", fixChildMenuPositions);

class AccordionDisclosure extends HTMLDetailsElement {
  constructor() {
    super();
    this.setAttribute('is', 'accordion-disclosure');
  }

  connectedCallback() {
    this.summary = this.firstElementChild;
    this.content = this.lastElementChild;
    this.subAccordions = this.querySelectorAll('details[is="accordion-disclosure"]');

    // Add tabindex and role for accessibility
    this.summary.setAttribute('tabindex', '0');

    // Set initial ARIA attributes
    this.setAttribute('aria-expanded', 'false');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));

    if (this.dataset?.accordionSyncGroup) {
      this.syncGroup = document.querySelectorAll(
        `details[is="accordion-disclosure"][data-accordion-sync-group="${this.dataset.accordionSyncGroup}"]`,
      );
    }

    if(Shopify?.designMode) {
      this.addEventListener("shopify:block:select", () => this.openAccordion());
      this.addEventListener("shopify:block:deselect", () => this.shrink());
    }

    // Check if should be open by default
    if (this.hasAttribute('open')) {
      this.openAccordion();
      this.setAttribute('aria-expanded', 'true');
    }

    this.summary.addEventListener("keydown", (event) => {
      // Prevent default behavior for these keys
      if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Enter", " "].includes(event.key)) {
        event.preventDefault();
      }

      switch (event.key) {
        case "ArrowDown":
        case "ArrowRight":
          if (!this.open) {
            this.onClick(event);
          } else if (this.content.querySelector('[tabindex="0"]')) {
            // Move focus to the first focusable element in content
            this.content.querySelector('[tabindex="0"]').focus();
          }
          break;
        case "ArrowUp":
        case "ArrowLeft":
          if (this.open) {
            this.shrink();
          }
          break;
        case "Enter":
        case " ": // Space key
          this.onClick(event);
          break;
      }
    });
  }

  onClick(e) {
    e.preventDefault();
    
    // Prevent interaction while animations are in progress
    if (this.isClosing || this.isExpanding) {
      return;
    }
    
    this.style.overflow = "hidden";
    if (!this.open) {
      this.openAccordion();
    } else {
      this.shrink();
    }
  }

  shrink(duration) {
    this.isClosing = true;
    this.setAttribute('aria-expanded', 'false');

    const startHeight = `${this.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: duration || 200,
        easing: "ease-out",
      },
    );

    this.content.animate(
      {
        opacity: [1, 0],
        transform: ["translateY(0px)", "translateY(4px)"]
      },
      {
        duration: 150,
        easing: "ease-out",
        fill: "forwards",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);

    this.subAccordions.forEach((accordion) => {
      if (accordion.open) {
        accordion.shrink();
        accordion.setAttribute('aria-expanded', 'false');
      }
    });
  }

  openAccordion() {
    if (this.syncGroup) {
      this.syncGroup.forEach((el) => {
        if (
          el !== this &&
          el.parentElement.closest('details[is="accordion-disclosure"]') !== this &&
          ![...el.querySelectorAll('details[is="accordion-disclosure"]')].some(
            (item) => item == this,
          )
        ) {
          if (el.open) {
            el.shrink();
            el.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }
    this.style.height = `${this.offsetHeight}px`;
    this.open = true;
    this.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(() => this.expand());
  }

  async expand() {
    this.isExpanding = true;
    const startHeight = `${this.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content?.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 250,
        easing: "ease",
      },
    );

    this.content.animate(
      {
        opacity: [0, 1],
        transform: ["translateY(4px)", "translateY(0)"]
      },
      {
        duration: 300,
        easing: "ease-out",
        fill: "forwards",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.style.height = this.style.overflow = "";
  }
}

customElements.define('accordion-disclosure', AccordionDisclosure, { extends: 'details' });

class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.options = {
      mapOptions: {
        zoom: 12,
        styles: [],
        markerIcon: null,
        apiKey: null
      }
    };
    this.locations = [];
  }

  connectedCallback() {
    this.loadConfigurations();
    this.initializeComponent();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  loadConfigurations() {
    // Load options from data-config-type="options"
    const optionsScript = this.querySelector('[data-config-type^="options"]');
    if (optionsScript) {
      try {
        const content = optionsScript.textContent.trim();
        if (content) {
          const parsedOptions = JSON.parse(content);
          this.options = { ...this.options, ...parsedOptions };
        }
      } catch (error) {
        console.warn('Error parsing options configuration:', error);
      }
    }
    
    // Load location data from location blocks
    const locationScripts = this.querySelectorAll('[data-config-type^="location"]');
    this.locations = []; 

    locationScripts.forEach(script => {
      try {
        // Fix common JSON formatting issues
        let fixedContent = script.textContent.trim()
          .replace(/,\s*]/g, ']')
          .replace(/,\s*}/g, '}');
        
        if (fixedContent) {
          const locationData = JSON.parse(fixedContent);
          
          if (locationData.stores && locationData.stores.length > 0) {
            // Add each store directly to our locations array
            locationData.stores.forEach(store => {
              this.locations.push({
                name: store.name,
                details: store.details || store.address || '',
                position: store.position
              });
            });
          } else if (locationData.name && locationData.position) {
            // Handle case where the location itself is a store
            this.locations.push({
              name: locationData.name,
              details: locationData.details || locationData.address || '',
              position: locationData.position
            });
          }
        }
      } catch (error) {
        console.warn('Error parsing location data:', error);
      }
    });
    
    // Load additional attributes
    const zoom = this.getAttribute('data-map-zoom');
    if (zoom && this.options.mapOptions) {
      this.options.mapOptions.zoom = parseInt(zoom, 10) || 12;
    }
    
    const markerIcon = this.getAttribute('data-marker-icon');
    if (markerIcon && this.options.mapOptions) {
      this.options.mapOptions.markerIcon = markerIcon;
    }
  }

  initializeComponent() {
    // Initialize map
    this.mapContainer = this.querySelector('.store-map-container');
    if (this.mapContainer) {
      this.initializeMap();
    }
    
    // Initialize tabs
    const detailsContainer = this.querySelector('.store-details-container');
    if (detailsContainer) {
      this.initializeTabs(detailsContainer);
    }
  }

  setupEventListeners() {
    // Listen for tab change events
    const tabComponent = this.querySelector('electric-tab');
    if (tabComponent) {
      tabComponent.addEventListener('tabChanged', this.handleTabChange.bind(this));
    }
  }

  removeEventListeners() {
    const tabComponent = this.querySelector('electric-tab');
    if (tabComponent) {
      tabComponent.removeEventListener('tabChanged', this.handleTabChange.bind(this));
    }
  }

  handleTabChange(event) {
    const tabIndex = event.detail.tabIndex;
    const store = this.locations[tabIndex];
    
    if (store?.position) {
      this.updateMap(store.position.lat, store.position.lng);
    }
  }

  updateMap(latitude, longitude) {
    if (!this.mapContainer || !latitude || !longitude) return;
    
    const apiKey = this.options.mapOptions?.apiKey;
    if (!apiKey) {
      console.error('Google Maps API key is missing');
      return;
    }
    
    const zoom = this.options.mapOptions?.zoom || 15;
    
    // Create a completely new iframe
    this.mapContainer.innerHTML = '';
    const iframe = document.createElement('iframe');
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = '0';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&zoom=${zoom}`;
    
    this.mapContainer.appendChild(iframe);
  }

  initializeMap() {
    if (this.locations.length === 0) return;
    
    const firstLocation = this.locations[0];
    if (firstLocation.position) {
      this.updateMap(firstLocation.position.lat, firstLocation.position.lng);
    }
  }

  initializeTabs(container) {
    container.innerHTML = '';
    
    if (this.locations.length === 0) {
      container.innerHTML = '<div class="p-4 text-center">No store locations found.</div>';
      return;
    }
    
    // Create electric-tab component
    const electricTab = document.createElement('electric-tab');
    electricTab.className = 'flex flex-col w-full';
    
    // Create buttons container with horizontal scrolling
    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'flex overflow-x-auto px-4 pb-2 border-b border-body/20 scrollbar-hide';
    buttonsContainer.style.scrollbarWidth = 'none'; // Firefox
    buttonsContainer.style.msOverflowStyle = 'none'; // IE/Edge
    
    // Create content container
    const contentsContainer = document.createElement('div');
    contentsContainer.className = 'flex flex-col gap-2 px-4 pt-2';
    
    // Create tab buttons and content for each store
    this.locations.forEach((store, index) => {
      // Create tab button
      const button = document.createElement('button');
      button.className = 'px-4 py-2 whitespace-nowrap transition-colors duration-200 shrink-0 lg:text-lg/solid text-body/50 hover:text-body';
      if (index === 0) {
        button.classList.add('text-body');
      }
      button.setAttribute('data-tab-button', '');
      button.setAttribute('data-tab-index', index.toString());
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `tab-${index}`);
      button.textContent = store.name || `Store ${index + 1}`;
      
      buttonsContainer.appendChild(button);
      
      // Create tab content
      const content = document.createElement('div');
      content.className = index === 0 ? '' : 'hidden';
      content.setAttribute('data-tab-content', '');
      content.setAttribute('data-tab-index', index.toString());
      content.setAttribute('id', `tab-${index}`);
      
      // Format the details with proper HTML
      const storeDetails = store.details || 'No details available';
      content.innerHTML = `<div class="p-4">${storeDetails}</div>`;
      
      contentsContainer.appendChild(content);
    });
    
    // Assemble and add to container
    electricTab.appendChild(buttonsContainer);
    electricTab.appendChild(contentsContainer);
    container.appendChild(electricTab);
    
    // Add custom CSS to hide scrollbar in WebKit browsers
    if (!document.querySelector('#scrollbar-hide-style')) {
      const style = document.createElement('style');
      style.id = 'scrollbar-hide-style';
      style.textContent = '.scrollbar-hide::-webkit-scrollbar { display: none; }';
      document.head.appendChild(style);
    }
  }
}

// ElectricTab component - handles tab switching only
class ElectricTab extends HTMLElement {
  constructor() {
    super();
    this.activeTabClass = 'text-body';
    this.inactiveTabClass = 'text-body/50';
    this.hiddenContentClass = 'hidden';
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('[data-tab-button]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');
    
    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this));
    });

    // Activate first tab by default
    if (this.tabButtons[0]) {
      this.tabButtons[0].click();
    }
  }

  disconnectedCallback() {
    this.tabButtons.forEach(button => {
      button.removeEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const button = event.currentTarget;
    const tabIndex = button.dataset.tabIndex;
    
    // Update tab buttons
    this.tabButtons.forEach(btn => {
      btn.classList.remove(this.activeTabClass);
      btn.classList.add(this.inactiveTabClass);
    });
    button.classList.add(this.activeTabClass);
    button.classList.remove(this.inactiveTabClass);

    // Update tab contents
    this.tabContents.forEach(content => content.classList.add(this.hiddenContentClass));
    const activeContent = this.querySelector(`[data-tab-content][data-tab-index="${tabIndex}"]`);
    if (activeContent) {
      activeContent.classList.remove(this.hiddenContentClass);
    }

    // Dispatch custom event for the parent component to handle
    this.dispatchEvent(new CustomEvent('tabChanged', {
      bubbles: true,
      detail: { tabIndex: parseInt(tabIndex, 10) }
    }));
  }
}

// Register the custom elements
customElements.define('store-locator', StoreLocator);
customElements.define('electric-tab', ElectricTab);

// document.addEventListener('DOMContentLoaded', function() {
//   gsap.registerPlugin(ScrollTrigger);

//   const heroSection = document.querySelector('.hero-section');
//   const bgImg = document.querySelector('.bg-image');
//   const fgImg = document.querySelector('.parallax-image');

//   if (heroSection && bgImg && fgImg) {
//     console.log('Parallax elements found:', { heroSection, bgImg, fgImg });

//     // Background image parallax
//     const bgTl = gsap.timeline({
//       scrollTrigger: {
//         trigger: heroSection,
//         start: 'top top',
//         end: 'bottom top',
//         scrub: 0.5,
//         onUpdate: (self) => {
//           console.log('Scroll progress:', self.progress);
//         }
//       }
//     });

//     bgTl.fromTo(bgImg, 
//       { y: 0 },
//       { y: 50, ease: slideEase }
//     );

//     // Foreground image parallax
//     const fgTl = gsap.timeline({
//       scrollTrigger: {
//         trigger: heroSection,
//         start: 'top top',
//         end: 'bottom+=400 top', // extend the end point
//         scrub: 0.5,
//         onUpdate: (self) => {
//           console.log('Scroll progress:', self.progress);
//         }
//       }
//     });

//     fgTl.fromTo(fgImg,
//       { y: 0 },
//       {
//         y: () => heroSection.offsetHeight * 0.2,
//         ease: 'none',
//         scrollTrigger: {
//           trigger: heroSection,
//           start: 'top bottom',
//           end: 'bottom top',
//           scrub: 1.5,
//           invalidateOnRefresh: true
//         }
//       }
//     );

//     const sectionContents = heroSection.querySelector('.section-contents');
//     const slideEase = 'power1.in';

//     if (sectionContents) {
//       const titleLines = sectionContents.querySelectorAll('h2, .text-solid-sm, a');
      
//       gsap.set(titleLines, { y: '100%', opacity: 0 });

//       ScrollTrigger.create({
//         trigger: sectionContents,
//         onEnter: () => {
//           gsap.to(titleLines, {
//             y: '0%',
//             opacity: 1,
//             duration: 0.75,
//             stagger: 0.3,
//             ease: slideEase
//           });
//         }
//       });
//     }
//     ScrollTrigger.refresh();
//   }
// });

class ProductImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
  const productLinks = this.querySelectorAll('.js-product-link');
  const productImages = this.querySelectorAll('.js-product-image');

  // create intersection observer, when collection image is partly in view, load all the productItems collection image in the background by creating new Img
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        productImages.forEach(image => {
          const img = new Image();
          img.src = image.src;
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  observer.observe([...productImages][0]);

  productLinks.forEach((link, index) => {
    link.addEventListener('mouseenter', function () {
      const previousImage = [...productImages].find(image => !image.classList.contains('hidden'));

      if (previousImage) {
        previousImage.style.transform = 'translateY(-5%)';
        previousImage.style.opacity = '0';
        setTimeout(() => {
          productImages.forEach(image => {
            image.classList.add('hidden')
          });
          [...productImages][index].classList.remove('hidden');
          [...productImages][index].style.transform = 'translateY(5%)';
          [...productImages][index].style.opacity = '0';
          setTimeout(() => {
            [...productImages][index].style.opacity = '1';
            [...productImages][index].style.transform = 'translateY(0)';
          }, 50)
        }, 50)
      }
    });
  })
  }
}

customElements.define('product-images', ProductImages);

class RevealStack extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.fonts.ready.then(() => { 
      this.init();
    });
  }

  init() {
    const children = Array.from(this.children);
    
    // Use reduce to keep track of total lines processed
    children.reduce((totalLines, child, index) => {
      // Only split text if the element has data-split="true"
      if (child.hasAttribute('data-split') && child.textContent.trim()) {
        const splitText = new SplitText(child, {
          type: "lines",
          linesClass: "line line++",
          onSplit: (self) => {
            // Wrap each line in a div for better control
            self.lines.forEach(line => {
              line.classList.add('overflow-hidden');
              const wrapper = document.createElement('div');
              wrapper.classList.add('overflow-hidden');
              line.parentNode.insertBefore(wrapper, line);
              wrapper.appendChild(line);
            });
            
            // Animate each line with stagger, adding delay based on total lines processed
            gsap.from(self.lines, {
              duration: 0.8,
              y: '100%',
              opacity: 0,
              ease: 'power4.out',
              stagger: 0.15,
              delay: totalLines * 0.15,
              scrollTrigger: {
                trigger: this,
                start: 'top 80%',
                once: true
              },
              onComplete: () => {
                // Revert split text and remove wrappers
                // self.revert();
                // Remove overflow-hidden class from the original element
                child.classList.remove('overflow-hidden');
              }
            });
            
            // Store the split text instance for cleanup
            child._splitText = self;
          }
        });
        
        
        // Return updated total lines count
        return totalLines + splitText.lines.length;
      } else {
        // For non-split elements, wrap them in a container for overflow control
        // child has margins, move the margins to the wrapper
        const wrapper = document.createElement('div');
        const innerWrapper = document.createElement('div');
        wrapper.classList.add('overflow-hidden');
        wrapper.style.marginTop = window.getComputedStyle(child).marginTop;
        wrapper.style.marginBottom = window.getComputedStyle(child).marginBottom;
        wrapper.style.marginLeft = window.getComputedStyle(child).marginLeft;
        wrapper.style.marginRight = window.getComputedStyle(child).marginRight;
        child.style.margin = '0';
        child.parentNode.insertBefore(wrapper, child);
        innerWrapper.appendChild(child);
        wrapper.appendChild(innerWrapper);

        const y = child.dataset.y || '100%';
        
        // Animate with the same style as text, adding delay based on total lines processed
        gsap.from(innerWrapper, {
          duration: 0.8,
          y: y,
          opacity: 0,
          ease: 'power4.out',
          delay: totalLines * 0.15,
          scrollTrigger: {
            trigger: this,
            start: '10% 80%',
            once: true
          },
          onComplete: () => {
            // Move the child back to its original position
            const parent = wrapper.parentNode;
            parent.insertBefore(child, wrapper);
            // Restore original margins
            child.style.margin = '';
            // Remove the wrapper
            parent.removeChild(wrapper);
          }
        });
        
        // Return updated total lines count (increment by 1 for non-split elements)
        return totalLines + 1;
      }
    }, 0); // Start with 0 total lines
    
    // Clean up on unmount
    this.addEventListener('unmount', () => {
      children.forEach(child => {
        if (child._splitText) {
          child._splitText.revert();
        }
      });
    });
  }
}

customElements.define('reveal-stack', RevealStack);

class ParallaxBackground extends HTMLElement {
  constructor() {
    super();
    this.preloadBackgroundImage();
  }

  connectedCallback() {
    if (!this.closest('animated-section')) {
      this.init();
    }
  }

  preloadBackgroundImage() {
    // Get the background image URL from the style attribute
    const style = this.getAttribute('style');
    if (style && style.backgroundImage) {
      const imageUrl = style.backgroundImage.replace('url(', '').replace(')', '');
      if (imageUrl) {
        // Create link preload element for highest priority
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = imageUrl;
        link.fetchPriority = 'high';
        document.head.appendChild(link);
        
        // Also create an Image object as backup
        const img = new Image();
        img.src = imageUrl;
      }
    }
  }

  init() {
      let { backgroundSize = 100, y = 100 } = this.dataset;
      let fromBackgroundSize = '';
      let toBackgroundSize = '';

      // detect the aspect ratio of the background image and 'this's ratio and switch the place of 'auto' in the gsap set and gsap to.
      const backgroundImage = this.style.backgroundImage;
      const backgroundImageUrl = backgroundImage.replace('url(', '').replace(')', '');
      // Skip if no background image or regex match failed
      if (!backgroundImage || !backgroundImageUrl) {
        return;
      }
      
      const backgroundImageObj = new Image();
      backgroundImageObj.src = backgroundImageUrl;
      const backgroundImageAspectRatio = parseInt(this.dataset.width) / parseInt(this.dataset.height);
      const thisAspectRatio = this.offsetWidth / this.offsetHeight;
      if (backgroundImageAspectRatio > thisAspectRatio) { 
        fromBackgroundSize = `auto ${backgroundSize}%`;
        toBackgroundSize = `auto 100%`;
      } else {
        fromBackgroundSize = `${backgroundSize}% auto`;
        toBackgroundSize = `100% auto`;
      }

      gsap.set(this, {
        backgroundPosition: `50% ${y}%`,
        backgroundSize: fromBackgroundSize
      })
      
      gsap.to(this, {
        backgroundPosition: '50% 50%',
        backgroundSize: toBackgroundSize,
        ease: 'none',
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
  }
}

customElements.define('parallax-background', ParallaxBackground);

class AnimatedSection extends HTMLElement {
  constructor() {
    super();
    this.parallaxItems = [];
  }

  connectedCallback() {
    ScrollTrigger.refresh();
    this.init();
  }

  init() {
    // Check if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.initParallaxItems();
    this.initParallaxBackground();
    this.initFadeInItems();
  }

  initFadeInItems() {
    this.fadeInItems = Array.from(this.querySelectorAll('fade-in-item'));
    this.fadeInItems.forEach(item => {
      // Set initial state
      gsap.set(item, {
        opacity: 0,
        y: 30
      });

      // Create scroll trigger
      ScrollTrigger.create({
        trigger: item,
        start: 'top 80%',
        onEnter: () => {
          gsap.to(item, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: 'power2.out'
          });
        },
        once: true
      });
    });
  }

  initParallaxBackground() {
    this.parallaxBackgrounds = Array.from(this.querySelectorAll('parallax-background'))

    this.parallaxBackgrounds.forEach(background => {
      background.init();
    });
  }

  initParallaxItems() {
    this.parallaxItems = Array.from(this.querySelectorAll('parallax-item'));
    
    this.parallaxItems.forEach(item => {
      const yPercent = parseInt(item.dataset.y) || 100;
      
      // Set initial position
      gsap.set(item, {
        yPercent: -yPercent
      });

      // Animate to final position
      gsap.to(item, {
        yPercent: yPercent,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          scrub: item.dataset.scrub || 0.8,
        }
      });
    });
  }
}

class ParallaxItem extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('animated-section', AnimatedSection);
customElements.define('parallax-item', ParallaxItem);

function initImageTextSliders() {
  document.querySelectorAll('.js-image-text-toggle').forEach((el) => {
    el.addEventListener('click', () => {
      el.classList.toggle('active');
    });
  });
}

['DOMContentLoaded', 'shopify:section:load'].forEach((event) => {
  document.addEventListener(event, initImageTextSliders);
});

// ... existing code ...



const normalize = (str) => str?.toString().trim().toLowerCase() || '';
class CountryStateProvinceSelector extends HTMLElement {
  constructor() {
    super();
    this.countrySelect   = null;
    this.stateSelect     = null;
    this.provinceSelect  = null;
    this.dealerBox       = null;
    this.cleanedDealers  = [];
  }

  connectedCallback() {
    this.countrySelect   = this.querySelector('#country');
    this.stateSelect     = this.querySelector('#states');
    this.provinceSelect  = this.querySelector('#province');
    this.dealerBox       = this.querySelector('#dealer-results');

    const rawDealers = JSON.parse(this.dataset.dealers);

    this.cleanedDealers = rawDealers.map(dealer => {
      return {
        address: dealer.address?.replaceAll('\\n','<br>')   || '',
        contact_info: dealer.contact_info?.replaceAll('\\n','<br>')   || '',
        country: normalize(dealer.country),
        google_maps:     dealer.google_maps?.replaceAll('\\/','/')         || '',
        name:   dealer.name || '',
        state:   normalize(dealer.state)
      }
    });
    console.log(rawDealers, this.cleanedDealers)

    this.countrySelect?.addEventListener('change', this.handleCountryChange.bind(this));
    this.stateSelect?.addEventListener('change',   this.handleStateProvinceChange.bind(this));
    this.provinceSelect?.addEventListener('change',this.handleStateProvinceChange.bind(this));

    // Hide state and province selectors by default
    this.hideStateProvinceSelectors();
    
    // Initialize with no results shown
    this.clearDealerResults();
  }

  disconnectedCallback() {
    this.countrySelect?.removeEventListener('change', this.handleCountryChange);
    this.stateSelect?.removeEventListener('change',   this.handleStateProvinceChange);
    this.provinceSelect?.removeEventListener('change',this.handleStateProvinceChange);
  }

  handleCountryChange() {
    this.hideStateProvinceSelectors();

    if (this.countrySelect.value === 'us') {
      this.stateSelect.style.display = 'block';
      this.stateSelect.disabled      = false;
      this.stateSelect.parentElement
        .querySelector('.pointer-events-none.absolute.right-4')
        .style.display = 'block';

      // If state is already selected, show results immediately
      if (this.stateSelect.value && this.stateSelect.value !== '') {
        this.handleStateProvinceChange();
      } else {
        // Otherwise, clear results and wait for state selection
        this.clearDealerResults();
      }
    } else if (this.countrySelect.value === 'ca') {
      this.provinceSelect.style.display = 'block';
      this.provinceSelect.disabled      = false;
      this.provinceSelect.parentElement
        .querySelector('.pointer-events-none.absolute.right-4')
        .style.display = 'block';

      // If province is already selected, show results immediately
      if (this.provinceSelect.value && this.provinceSelect.value !== '') {
        this.handleStateProvinceChange();
      } else {
        // Otherwise, clear results and wait for province selection
        this.clearDealerResults();
      }
    } else {
      // For other countries, check if there are dealers in this country
      const selectedCountry = normalize(
        this.countrySelect.options[this.countrySelect.selectedIndex].text
      );
      const matching = this.cleanedDealers.filter(d => d.country === selectedCountry);
      
      this.updateDealerResults(matching);
    }
  }

  handleStateProvinceChange() {
    const selectedCountry = normalize(
      this.countrySelect.options[this.countrySelect.selectedIndex].text
    );
    const regionSelect = this.countrySelect.value === 'us' ? this.stateSelect : this.provinceSelect;
    const selectedRegion = normalize(regionSelect.value);

    const matching = this.cleanedDealers.filter(d =>
      d.country === selectedCountry &&
      d.state.includes(selectedRegion)
    );

    this.updateDealerResults(matching);
  }

  updateDealerResults(matchingDealers) {
    this.dealerBox.innerHTML = '';
    this.dealerBox.style.display = '';

    if (matchingDealers && matchingDealers.length) {
      matchingDealers.forEach(dealer => {
        this.dealerBox.innerHTML += `
          <div class="uppercase bg-beige ${this.dataset.inline === 'false' ? 'p-4 lg:p-12 lg:w-1/3 w-full' : ''}">
            ${
              dealer.logo
                ? `<img src="${dealer.logo}" alt="${dealer.name} logo" class="object-contain mb-6 w-48" loading="lazy" decoding="async" />`
                : ''
            }
            <h4 class="mb-2 font-bold">${dealer.name}</h4>
            <p>${dealer.address}</p>
            <h4 class="mt-4 mb-2 font-bold">Contact</h4>
            <p>${dealer.contact_info}</p>
            ${dealer.google_maps
              ? `<a href="${dealer.google_maps}" class="block mt-2 underline">Open Google Maps</a>`
              : ''
            }
          </div>`;
      });
    } else {
      this.showHQFallback();
    }
  }

  clearDealerResults() {
    this.dealerBox.innerHTML = '';
    this.dealerBox.style.display = 'none';
  }

  hideStateProvinceSelectors() {
    [this.stateSelect, this.provinceSelect].forEach(sel => {
      if (!sel) return;
      sel.style.display  = 'none';
      sel.disabled       = true;
      sel.parentElement
        .querySelector('.pointer-events-none.absolute.right-4')
        ?.style.setProperty('display','none');
    });
  }

  showHQFallback() {
    const hq = this.cleanedDealers.find(d => d.name.toLowerCase().includes('hq'));
    const hq_index = this.cleanedDealers.findIndex(d => d.name.toLowerCase().includes('hq'));
    if (hq) {
      this.dealerBox.innerHTML = `
        <div class="uppercase bg-beige ${this.dataset.inline === 'false' ? 'p-4 lg:p-12 lg:w-1/3 w-full' : ''}">
          ${
            this.dataset.logos.split(',')[hq_index]
              ? `<img src="${this.dataset.logos.split(',')[hq_index]}" alt="${hq.name} logo" class="object-contain mb-6 w-48" loading="lazy" decoding="async" />`
              : ''
          }
          <h4 class="mb-2 font-bold">${hq.name}</h4>
          <p>${hq.address}</p>
          <h4 class="mt-4 mb-2 font-bold">Contact</h4>
          <p>${hq.contact_info}</p>
          ${hq.google_maps
            ? `<a href="${hq.google_maps}" class="block mt-2 underline">Open Google Maps</a>`
            : ''
          }
        </div>`;
    } else {
      this.dealerBox.innerHTML = `<p>No dealers found.</p>`;
    }
  }
}

customElements.define('country-state-province-selector', CountryStateProvinceSelector);

class collectionGrid extends HTMLElement {
  constructor(){
    super();
    this.dataTag = document.querySelectorAll('.data-tag');
    this.productTag = document.querySelectorAll('.data-product-tag');
    this.dataTag.forEach(data => {
      this.dataValue = data.dataset.value;
    });
    this.productTag.forEach(tag => {
      console.log(tag.dataset.productTag);
      if(this.dataValue == tag.dataset.productTag){
        
      }
    });
  }
}

customElements.define('collection-grid', collectionGrid);

/**
 * Simple Modal System
 * 
 * Creates a single modal container that handles all modal interactions.
 * Uses Tailwind classes for styling and animations.
 * Content is dynamically loaded/updated instead of creating multiple modal instances.
 */

class SimpleModal {
  constructor() {
    this.modal = null;
    this.backdrop = null;
    this.content = null;
    this.previousFocus = null;
    this.isOpen = false;
    this.scrollPosition = 0;
    
    this.init();
  }
  
  init() {
    // Create single modal container
    this.createModalContainer();
    
    // Setup event listeners
    this.setupTriggers();
    this.setupKeyboardListeners();
  }
  
  createModalContainer() {
    // Create modal HTML structure
    const modalHTML = `
      <div 
        id="app-modal" 
        class="fixed inset-0 z-[9999] hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <!-- Backdrop -->
        <div 
          class="fixed inset-0 app-modal-backdrop fade-in bg-black/50"
          data-modal-close
        ></div>
        
        <!-- Modal container -->
        <div class="overflow-y-auto fixed inset-0 p-4 pointer-events-none sm:p-6">
          <div class="flex justify-center items-center min-h-full">
            <!-- Modal content -->
            <div 
              class="relative bg-white shadow-xl pointer-events-auto app-modal-content slide-up-sm w-fit rounded-lg lg:rounded-[24px] overflow-hidden"
              role="document"
            >
              <!-- Content will be inserted here -->
            </div>
          </div>
        </div>
      </div>
    `;
    
    // Add to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Cache elements
    this.modal = document.getElementById('app-modal');
    this.backdrop = this.modal.querySelector('.app-modal-backdrop');
    this.content = this.modal.querySelector('.app-modal-content');
    
    // Setup backdrop click handler
    this.backdrop.addEventListener('click', () => this.close('backdrop'));
  }
  
  setupTriggers() {
    // Use event delegation for modal triggers
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (!trigger) return;
      
      e.preventDefault();
      
      const modalId = trigger.dataset.modalTrigger;
      const data = this.collectTriggerData(trigger);
      
      this.open(modalId, data);
    });
  }
  
  setupKeyboardListeners() {
    document.addEventListener('keydown', (e) => {
      if (!this.isOpen) return;
      
      if (e.key === 'Escape') {
        this.close('escape');
      }
      
      // Focus trap
      if (e.key === 'Tab') {
        this.handleTabKey(e);
      }
    });
  }
  
  collectTriggerData(trigger) {
    const data = {};
    
    // Collect all data-modal-* attributes
    Array.from(trigger.attributes).forEach(attr => {
      if (attr.name.startsWith('data-modal-') && attr.name !== 'data-modal-trigger') {
        const key = attr.name.replace('data-modal-', '');
        data[key] = attr.value;
      }
    });
    
    return data;
  }
  
  async open(modalId, data = {}) {
    if (this.isOpen) return;
    
    try {
      // Store current focus
      this.previousFocus = document.activeElement;
      
      // Load content
      await this.loadContent(modalId, data);
      
      // Lock body scroll
      this.lockBodyScroll();
      
      // Show modal
      this.modal.classList.remove('hidden');
      
      // Set state
      this.isOpen = true;
      
      // Focus management
      this.trapFocus();
      
      // Dispatch event
      this.dispatchEvent('modal:open', { modalId, data });
      
    } catch (error) {
      console.error('Error opening modal:', error);
      this.close();
    }
  }
  
  async loadContent(modalId, data) {
    // Show loading state
    this.content.innerHTML = `
      <div class="p-8 text-center">
        <div class="inline-block w-6 h-6 rounded-full border-2 border-gray-300 animate-spin border-t-gray-900"></div>
        <p class="mt-2 text-sm text-gray-600">Loading...</p>
      </div>
    `;
    
    // Check if there's a template element for this modal
    const template = document.querySelector(`template[data-modal-content="${modalId}"]`);
    
    if (template) {
      // Use template content
      this.content.innerHTML = template.innerHTML;
      
      // Replace any template variables with data
      this.replaceTemplateVariables(data);
      
    } else {
      // Try to find existing modal content
      const existingModal = document.querySelector(`[data-modal-id="${modalId}"]`);
      
      if (existingModal) {
        this.content.innerHTML = existingModal.innerHTML;
      } else {
        // Fallback content
        this.content.innerHTML = `
          <div class="p-6">
            <h3 class="mb-4 text-lg font-medium">Modal</h3>
            <p class="mb-6 text-gray-600">Modal content for "${modalId}"</p>
            <div class="flex justify-end">
              <button 
                type="button" 
                class="px-4 py-2 text-white bg-gray-500 rounded hover:bg-gray-600"
                data-modal-close
              >
                Close
              </button>
            </div>
          </div>
        `;
      }
    }
    
    // Setup close buttons
    this.setupCloseButtons();
  }
  replaceTemplateVariables(data) {
    const html = this.content.innerHTML;
    
    Object.keys(data).forEach(key => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      this.content.innerHTML = this.content.innerHTML.replace(regex, data[key] || '');
    });
  }
  
  setupCloseButtons() {
    const closeButtons = this.content.querySelectorAll('[data-modal-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close('button'));
    });
  }
  
  close(reason = 'programmatic') {
    if (!this.isOpen) return;
    
    try {
      // Dispatch closing event (cancelable)
      const closingEvent = this.dispatchEvent('modal:closing', { reason });
      if (closingEvent.defaultPrevented) return;

      // this.backdrop.animate({
      //   opacity: [1, 0]
      // }, {
      //   duration: 300,
      //   easing: 'ease-in',
      //   fill: 'forwards'
      // });

      // this.content.animate({
      //   transform: ['translateY(0)', 'translateY(0.625rem)'],
      //   opacity: [1, 0]
      // }, {
      //   duration: 300,
      //   easing: 'ease-in',
      //   fill: 'forwards'
      // });

      // Wait for animations to complete
        // Hide modal
        this.modal.classList.add('hidden');

        // this.backdrop.animate({
        //   opacity: [0, 1]
        // }, {
        // });

        // this.content.animate({
        //   opacity: [0, 1]
        // }, {
        //   duration: 300,
        //   easing: 'ease-in',
        //   fill: 'forwards'
        // });
        
        // Restore body scroll
        this.unlockBodyScroll();
        
        // Restore focus
        if (this.previousFocus && this.previousFocus.focus) {
          console.log('focusing', this.previousFocus);
          // buggy, scrolls
          // this.previousFocus.focus();
        }
        
        // Clear content
        this.content.innerHTML = '';
        
        // Set state
        this.isOpen = false;
        
        // Dispatch closed event
        this.dispatchEvent('modal:closed', { reason });
        
      
    } catch (error) {
      console.error('Error closing modal:', error);
    }
  }
  
  lockBodyScroll() {
    if (typeof lockScrollForThis === 'function') {
      lockScrollForThis(this.modal);
    } else {
      // Fallback if helpers not available
      this.scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    }
  }
  
  unlockBodyScroll() {
    if (typeof unlockScrollForThis === 'function') {
      unlockScrollForThis(this.modal);
    } else {
      // Fallback if helpers not available
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (this.scrollPosition) {
        window.scrollTo(0, this.scrollPosition);
      }
    }
  }
  
  trapFocus() {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }
  
  handleTabKey(e) {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }
  
  dispatchEvent(name, detail = {}) {
    const event = new CustomEvent(name, {
      detail,
      bubbles: true,
      cancelable: name === 'modal:closing'
    });
    
    document.dispatchEvent(event);
    return event;
  }
  
  // Public API methods
  static open(modalId, data = {}) {
    if (window.simpleModal) {
      return window.simpleModal.open(modalId, data);
    }
  }
  
  static close(reason = 'programmatic') {
    if (window.simpleModal) {
      return window.simpleModal.close(reason);
    }
  }
  
  static isOpen() {
    return window.simpleModal ? window.simpleModal.isOpen : false;
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.simpleModal = new SimpleModal();
  });
} else {
  window.simpleModal = new SimpleModal();
}

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = SimpleModal;
}
  document.addEventListener('DOMContentLoaded', () => {
    const policyWrapper = document.querySelector('.shopify-policy__container');
    const policyTitle = document.querySelector('.shopify-policy__title');
    const policyBodyWrapper = document.querySelector('.shopify-policy__body');
    const policyBodyText = document.querySelector('.rte');
    const policySubTitles = policyBodyWrapper.querySelectorAll('h2');

    if (!policyTitle) {
      policyBodyWrapper.classList.add('items-center', 'justify-center');
      console.log('No policy title found');
      return;
    }

    const customNavWrapper = document.createElement('div');
    customNavWrapper.classList.add(
      'custom-nav-wrapper',
      'rounded-2xl',
      'bg-gray-tone1'
    );
    const policyNavWrapper = document.createElement('div');
    policyNavWrapper.classList.add('policy-nav-wrapper', 'flex', 'flex-col', 'lg:sticky', 'top-24', 'left-0', 'lg:h-[580px]');

    const tocHeader = document.createElement('h5');
    tocHeader.classList.add('px-6', 'py-[19px]', 'border-b', 'border-burgundy-20');
    tocHeader.textContent = 'Table of content';

    const customSubtitlesWrapper = document.createElement('ul');
    customSubtitlesWrapper.classList.add(
      'custom-subtitles-wrapper',
      'flex',
      'flex-col',
      'gap-4',
      'pr-6',
      'py-4',
      'overflow-auto',
      'h-[200px]',
      'lg:h-[296px]',
      'overflow-scroll'
    );

    policySubTitles.forEach((subtitle, index) => {
      const entry = document.createElement('li');
      entry.classList.add('subtitle-entry', 'flex', 'items-center', 'gap-2');

      const placeholder = document.createElement('span');
      placeholder.classList.add(
        'highlight-placeholder',
        'flex',
        'h-[19px]',
        'w-[2px]',
        'rounded-[100px]',
        'invisible'
      );

      const link = document.createElement('a');
      link.classList.add('body-4', 'pl-6');
      link.textContent = `${index + 1}. ${subtitle.textContent.trim()}`;
      link.href = `#subtitle-${index}`;
      subtitle.id = `subtitle-${index}`;

      entry.appendChild(placeholder);
      entry.appendChild(link);
      customSubtitlesWrapper.appendChild(entry);
    });

    const progressSection = document.createElement('div');
    progressSection.classList.add('py-2', 'border-burgundy-20', 'hidden', 'lg:block');

    const progressLabel = document.createElement('div');
    progressLabel.classList.add('flex', 'justify-between', 'items-center', 'mb-2');

    const progressTrack = document.createElement('div');
    progressTrack.classList.add('w-full', 'h-1', 'bg-gray-200', 'rounded-full');

    const progressFill = document.createElement('div');
    progressFill.classList.add('h-full', 'bg-burgundy', 'rounded-full', 'transition-all', 'duration-50');
    progressFill.style.width = '0%';

    progressTrack.appendChild(progressFill);
    progressSection.appendChild(progressLabel);
    progressSection.appendChild(progressTrack);

    customNavWrapper.appendChild(tocHeader);
    customNavWrapper.appendChild(customSubtitlesWrapper);
    policyNavWrapper.appendChild(customNavWrapper);
    policyNavWrapper.appendChild(progressSection);

    policyBodyWrapper.insertBefore(policyNavWrapper, policyBodyText);
    policyWrapper.classList.add('!m-0', '!w-full', '!max-w-none', '!p-0');
    policyTitle.classList.add('!text-left', '!pl-5', 'relative', 'pt-[64px]', 'pb-[51px]', 'lg:pt-[110px]', 'lg:pb-[62px]', 'container');
    policyBodyWrapper.classList.add(
      '!bg-white',
      '!px-8',
      '!pt-12',
      '!pb-24',
      '!-mb-6',
      'container',
      'rounded-t-4xl',
      'flex',
      'relative',
      'gap-12',
      'flex-col',
      'lg:flex-row',
      'justify-center'
    );
    policyBodyText.classList.add('lg:!w-2/3');

    
    if(window.location.href.includes('refund-policy')) {
      policyNavWrapper.classList.add('hidden')
    }

    const listItems = customSubtitlesWrapper.querySelectorAll('li a');

    // --- Highlight logic based on scroll ---
    function updateActiveLink() {
      let closest = null;
      let closestIndex = 0;
      let minDistance = Infinity;

      policySubTitles.forEach((subtitle, index) => {
        const rect = subtitle.getBoundingClientRect();
        const distance = Math.abs(rect.top - 120);
        if (distance < minDistance) {
          minDistance = distance;
          closest = subtitle;
          closestIndex = index;
        }
      });


      const headerOffset = 240; // px of sticky header height
      const scroll = document.documentElement.scrollTop || document.body.scrollTop;
      const total = (document.documentElement.scrollHeight - document.documentElement.clientHeight) - headerOffset;
      
      const percent = total > 0 ? (scroll / total) * 100 : 0;
      progressFill.style.width = `${Math.min(percent, 100)}%`;
      

      if (closest) {
        listItems.forEach((li) => {
          li.classList.remove('font-bold', 'text-burgundy');

          const span = li.previousElementSibling;
          if (span && span.classList.contains('highlight-bar')) {
            span.classList.remove('bg-burgundy');
            span.classList.add('invisible');
            span.classList.add('highlight-placeholder');
            span.classList.remove('highlight-bar');
          }
        });

        const activeLink = customSubtitlesWrapper.querySelector(`a[href="#${closest.id}"]`);
        const activeSpan = activeLink.previousElementSibling;

        if (activeSpan && activeSpan.classList.contains('highlight-placeholder')) {
          activeSpan.classList.remove('highlight-placeholder', 'invisible');
          activeSpan.classList.add('highlight-bar', 'bg-burgundy');
        }

        activeLink.classList.add('font-bold', 'text-burgundy');
        
        // Scroll the active item into view within the subtitles wrapper
        const activeListItem = activeLink.closest('li');
        if (activeListItem) {
          // Add some padding by scrolling to a position that gives breathing room
          const containerRect = customSubtitlesWrapper.getBoundingClientRect();
          const itemRect = activeListItem.getBoundingClientRect();
          const scrollTop = customSubtitlesWrapper.scrollTop;
          
          // Calculate the position with padding (16px from top and bottom)
          const padding = 16;
          const targetScrollTop = scrollTop + (itemRect.top - containerRect.top) - padding;
          
          customSubtitlesWrapper.scrollTo({
            top: Math.max(0, targetScrollTop),
            behavior: 'smooth'
          });
        }
      }
    }

    window.addEventListener('scroll', updateActiveLink);
    updateActiveLink();
  });
